<template>
  <div class="fpaDetail">
    <div>
      <p class="icon-jujue closeBtn" @click="routerBack"></p>
    </div>
    <el-row class="btn" type="flex" justify="start" align="middle" v-if="canUpdate||isAttachmentUpload||formData.canAudit||ssApprove||hgsApprove||isSignUpload||canSupplierSign||ssReApprove||formData.canReturn||canSsDirectorApprove||canSnrDirectorApprove||canFdApprove||canScmVpApprove||canCfoVpApprove||canCeoApprove||lmApprove||lmReApprove||canHlmApprove">
      <!--新建时保存提交-->
      <el-button v-if="canUpdate" type="primary" @click="fpaSave">Save As Draft</el-button>
      <el-button v-if="canUpdate" :loading="isSubmitLoading" :disabled="isSubmitDisabled" type="primary" @click="fpaSubmit">Submit</el-button>
      <el-button v-if="isAttachmentUpload" type="primary" @click="attachmentUpload('1')">{{ $t('fpaManage.permanent.attachmentUpload')}}</el-button>
      <!--mdm检查-->
      <el-button v-if="formData.canAudit" type="primary" @click="fpaApprove('approving')">Approve</el-button>
      <el-button v-if="formData.canAudit" type="primary" @click="fpaApprove('reject')">Reject</el-button>
      <!--待ss初审-->
      <el-button v-if="ssApprove" type="primary" @click="fpaApprove('approving')">Approve</el-button>
      <el-button v-if="ssApprove" type="primary" @click="fpaApprove('reject')">Reject</el-button>
      <!--2023.10.30-待Logistic Manager的初审-->
      <el-button v-if="lmApprove" type="primary" @click="fpaApprove('approving')">Approve</el-button>
      <el-button v-if="lmApprove" type="primary" @click="fpaApprove('reject')">Reject</el-button>
      <!--2023.10.30-待Logistic Manager审批-->
      <el-button v-if="lmReApprove" type="primary" @click="fpaApprove('approving')">Approve</el-button>
      <el-button v-if="lmReApprove" type="primary" @click="fpaApprove('reject')">Reject</el-button>
      <el-button v-if="lmReApprove" type="primary" @click="returnToSu">{{$t('fpaManage.permanent.returnToSupplier')}}</el-button>
      <!--2023.10.30-待Head of Logistic Management审批-->
      <!-- <el-button v-if="hlmApprove" type="primary" @click="fpaApprove('approving')">Approve</el-button>
      <el-button v-if="hlmApprove" type="primary" @click="fpaApprove('reject')">Reject</el-button> -->
      <!-- HGS预审审批 -->
      <el-button v-if="hgsApprove" type="primary" @click="fpaApprove('approving')">Approve</el-button>
      <el-button v-if="hgsApprove" type="primary" @click="fpaApprove('reject')">Reject</el-button>
      <!--待签字附件上传-->
      <el-button v-if="isSignUpload" type="primary" @click="attachmentUpload('0')">{{$t('fpaManage.permanent.signatureUpload')}}</el-button>
      <el-button v-if="canSupplierSign" type="primary" @click="suSignSubmit">Submit</el-button>
      <!--ssCategoryLeader再审-->
      <el-button v-if="ssReApprove" type="primary" @click="fpaApprove('approving')">Approve</el-button>
      <el-button v-if="ssReApprove" type="primary" @click="fpaApprove('reject')">Reject</el-button>
      <el-button v-if="ssReApprove || formData.canReturn" type="primary" @click="returnToSu">{{$t('fpaManage.permanent.returnToSupplier')}}</el-button>
      <!--各级领导审批-->
      <el-button v-if="canSsDirectorApprove" type="primary" @click="fpaApprove('approving')">Approve</el-button>
      <el-button v-if="canSsDirectorApprove" type="primary" @click="fpaApprove('reject')">Reject</el-button>
      <el-button v-if="canSnrDirectorApprove" type="primary" @click="fpaApprove('approving')">Approve</el-button>
      <el-button v-if="canSnrDirectorApprove" type="primary" @click="fpaApprove('reject')">Reject</el-button>
      <el-button v-if="canFdApprove" type="primary" @click="fpaApprove('approving')">Approve</el-button>
      <el-button v-if="canFdApprove" type="primary" @click="fpaApprove('reject')">Reject</el-button>
      <el-button v-if="canScmVpApprove" type="primary" @click="fpaApprove('approving')">Approve</el-button>
      <el-button v-if="canScmVpApprove" type="primary" @click="fpaApprove('reject')">Reject</el-button>
      <el-button v-if="canCfoVpApprove" type="primary" @click="fpaApprove('approving')">Approve</el-button>
      <el-button v-if="canCfoVpApprove" type="primary" @click="fpaApprove('reject')">Reject</el-button>
      <el-button v-if="canCeoApprove" type="primary" @click="fpaApprove('approving')">Approve</el-button>
      <el-button v-if="canCeoApprove" type="primary" @click="fpaApprove('reject')">Reject</el-button>
      <el-button v-if="canHlmApprove" type="primary" @click="fpaApprove('approving')">Approve</el-button>
      <el-button v-if="canHlmApprove" type="primary" @click="fpaApprove('reject')">Reject</el-button>
    </el-row>
    <el-form :model="formData" ref="formData1" label-width="230px" label-position="left">
      <div class="view_content">
        <div class="fpaNo">
          <p>FPA NO:</p>
          <p>{{formData.fpaNo}}</p>
        </div>
        <div class="status">
          <p>Status:</p>
          <p>{{formData.queryStatus}}</p>
        </div>
        <div class="creator">
          <p>Creator:</p>
          <p>{{formData.createUser}}</p>
        </div>
        <div class="createDate">
          <p>Creation Date:</p>
          <p>{{formData.createDate}}</p>
        </div>
        <div class="approver">
          <p>Last Approver:</p>
          <p>{{formData.lastApprover}}</p>
        </div>
      </div>
      <div class="info_box">
        <!-- Basic Information -->
        <div class="info_box_lf">
          <div class="info_box_title">
            <p class="line"></p>
            <p class="info_title">Basic Information</p>
          </div>
          <!-- Purpose of the Agreemen -->
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item prop="purposeOfTheAgreement" style="width:100%">
                <p slot="label">
                  <span class="icon-fenlei element_icon"></span>
                  Purpose of the Agreement
                </p>
                <el-select v-model="formData.agreementPurpose" :disabled="!canUpdate" style="width:100%">
                  <el-option :key="index" v-for="(item,index) in agreementPurposeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- category1 category2-->
          <el-row :gutter="20">
            <el-col :span="13">
              <el-form-item prop="category1" :rules="fpaRules1.category1" style="width:100%">
                <p slot="label" class="required_p">
                  <span class="icon-leimu2 element_icon"></span>
                  Category1
                </p>
                <el-select v-model="formData.category1" clearable :disabled="ttFpaId >0 " @change="changeCategory1()" style="width:100%">
                  <el-option :key="index" v-for="(item,index) in category1List" :label="item.name" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item prop="category2" label="Category2" :rules="fpaRules1.category2" label-width="140px" style="width:100%">
                <el-select v-model="formData.category2" clearable :disabled="ttFpaId >0 " @change="changeCategory2" style="width:100%">
                  <el-option :key="index" v-for="(item,index) in category2List" :label="item.name" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- Supplier -->
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item prop="supplierName" :rules="fpaRules1.supplierName" style="width:100%">
                <p slot="label" class="required_p">
                  <span class="icon-yonghutianchong element_icon"></span>
                  Supplier
                </p>
                <el-input v-if="canUpdate" class="handle-input" v-model="formData.supplierName" :title="formData.supplierName">
                  <el-button class="input-search" slot="append" icon="el-icon-search" @click.native="supplierChoose"></el-button>
                </el-input>
                <el-input v-else disabled class="handle-input" v-model="formData.supplierName" :title="formData.supplierName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- Product or Commodity -->
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item prop="productOrCommodityPurchased" :rules="fpaRules1.productOrCommodityPurchased" style="width:100%">
                <p slot="label" class="required_p">
                  <span class="icon-miaoshu element_icon"></span>
                  Product or Commodity Purchased
                </p>
                <el-input :disabled="!canUpdate" v-model="formData.productOrCommodityPurchased" :title="formData.productOrCommodityPurchased"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- Agreement Start Date Agreement End Date -->
          <el-row :gutter="20">
            <el-col :span="13">
              <el-form-item prop="agreementStartDate" :rules="fpaRules1.agreementStartDate" style="width:100%">
                <p slot="label" class="required_p">
                  <span class="icon-riqi element_icon" style="font-size:24px!important"></span>
                  Agreement Start Date
                </p>
                <el-date-picker :disabled="!canUpdate" style="width:100%" type="date" placeholder="选择日期" v-model="formData.agreementStartDate" value-format="yyyy-MM-dd" :picker-options="pickerOptionsStart"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item prop="agreementEndDate" :rules="fpaRules1.agreementEndDate" label="Agreement End Date" label-width="140px" style="width:100%">
                <el-date-picker :disabled="!canUpdate" style="width:100%" type="date" placeholder="选择日期" v-model="formData.agreementEndDate" value-format="yyyy-MM-dd" :picker-options="pickerOptionsEnd"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- Purchase Frequency -->
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item prop="purchaseFrequency" :rules="fpaRules1.purchaseFrequency" style="width:100%">
                <p slot="label">
                  <span class="icon-pinshuai1 element_icon"></span>
                  Purchase Frequency
                </p>
                <el-input :disabled="!canUpdate" v-model="formData.purchaseFrequency" :title="formData.purchaseFrequency"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- Currency -->
          <el-row :gutter="20" v-if="formData.category2 == 'Toys'">
            <el-col :span="13">
              <el-form-item prop="currency" :rules="fpaRules1.currency" style="width:100%">
                <p slot="label">
                  <span class="icon-qianbi element_icon"></span>
                  Currency
                </p>
                <ic-select table="BASE" field="CURRENCY_CODE" :disabled="!canUpdate " v-model="formData.currency" @change="changeToysCurrency()" style="width:100%"></ic-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- Notional  Value of Agreement -->
        <div class="info_box_rg">
          <div v-if="formData.category2=='package-service' || formData.category2=='toy-service' || formData.category2=='planning-service'|| formData.category2=='Toys'">
            <div class="info_box_title">
              <p class="line"></p>
              <p class="info_title">
                Notional Value of Agreement
                <span v-if="formData.category2!='Toys'">(total amount in RMB with VAT)</span>
                <span v-if="formData.category2=='Toys'">(total amount with VAT)</span>
              </p>
            </div>
            <div class="price_box2">
              <span class="icon-huobi qian"></span>
              <p class="notional_qian" v-if="(formData.category2!='package-service' && formData.category2!='toy-service'&&formData.category2!='planning-service') || !canUpdate">{{formData.notionalValueOfAgreement}}</p>
              <el-form-item prop="notionalValueOfAgreement" :rules="fpaRules1.notionalValueOfAgreement" style="width:80%;margin-bottom:0;" label-width="0" v-else>
                <el-input oninput="value=value.replace(/[^0-9]/g,'')" v-model="formData.notionalValueOfAgreement" :title="formData.notionalValueOfAgreement"></el-input>
              </el-form-item>
            </div>
          </div>
          <div v-else>
            <div class="info_box_title">
              <p class="line"></p>
              <p class="info_title">Notional Value of Agreement (total amount in RMB with VAT)</p>
            </div>
            <div class="price_box2">
              <span class="icon-huobi qian"></span>
              <p class="notional_qian">{{formData.notionalValueOfAgreement}}</p>
            </div>
          </div>
          <div class="info_box_title" style="margin-top:10px">
            <p class="line"></p>
            <p class="info_title">Coverage</p>
          </div>
          <!-- Coverage table -->
          <div class="coverage_table" v-if="formData.category2!='logistic'&&formData.category2!='planning-service'">
            <el-table :data="formData.fpaSupplierCoverageList" border max-height="124px" highlight-current-row @selection-change="handleSupplierCoverageChange">
              <el-table-column v-if="canUpdate" align="center" type="selection" width="55">
              </el-table-column>
              <el-table-column prop="plantName" label="Supplier Facility" width="150px">
              </el-table-column>
              <el-table-column prop="coverage" label="Supplier Coverage">
                <template slot-scope="scope">
                  <el-input :disabled="!canUpdate" type="number" v-model="scope.row.coverage" style="width:40%;"></el-input> % in terms of annual capacity utilization
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- Coverage total -->
          <div style="margin-top:10px" v-if="formData.category2!='logistic'&&formData.category2!='planning-service'" class="total_box">
            <el-form-item prop="supplierCoverageTotal" label-width="64px" label-position="right" class="totalForm">
              <span slot="label">
                <span class="icon-heji element_icon"></span>
                <span>&nbsp;&nbsp;Total</span>
              </span>
              <el-input onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,4})?).*$/g, '$1')" v-model="formData.supplierCoverageTotal" style="width: 40%"></el-input>
              <span>% in terms of annual business revenue</span>
            </el-form-item>
          </div>
          <!-- Coverage table -->
          <div class="coverage_table" v-if="formData.category2=='logistic'||formData.category2=='planning-service'">
            <el-table :data="formData.fpaDcCoverageList" border max-height="124px" highlight-current-row @selection-change="handleDcCoverageChange">
              <el-table-column v-if="canUpdate" align="center" type="selection" width="55"></el-table-column>
              <el-table-column prop="dcName" label="Supplier DC" width="150px">
              </el-table-column>
              <el-table-column prop="coverage" label="Supplier Coverage">
                <template slot-scope="scope">
                  <el-input :disabled="!canUpdate" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,4})?).*$/g, '$1')" v-model="scope.row.coverage" style="width:40%;"></el-input> % in terms of annual capacity utilization
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- Coverage total -->
          <div style="margin-top:10px" v-if="formData.category2=='logistic'||formData.category2=='planning-service'" class="total_box">
            <el-form-item prop="supplierCoverageTotal" label-width="100px" label-position="right" class="totalForm">
              <span slot="label">
                <span class="icon-heji element_icon"></span>
                <span>&nbsp;&nbsp;Total</span>
              </span>
              <el-input :disabled="!canUpdate" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,4})?).*$/g, '$1')" v-model="formData.supplierCoverageTotal" style="width: 40%"></el-input>
              <span>% in terms of annual business revenue</span>
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="price_info" v-if="formData.category2=='package-service' || formData.category2=='toy-service'|| formData.category2=='planning-service' || formData.category2=='Toys'">
        <div class="info_box_title" style="padding-top:10px">
          <p class="line"></p>
          <p class="info_title">Price Information</p>
        </div>
        <!-- Agreed Price agreedPriceWithVat-->
        <el-row :gutter="20" v-if="formData.category2=='package-service' || formData.category2=='toy-service'|| formData.category2=='planning-service' || formData.category2=='Toys'">
          <el-col :span="9">
            <el-form-item prop="agreedPriceWithVat" :rules="fpaRules1.agreedPriceWithVat" style="width:100%" label-width="230px">
              <p slot="label">Agreed Price</p>
              <p slot="label" style="line-height: 1;" v-if="formData.category2!='Toys'">(price/case or tray in RMB with VAT)</p>
              <p slot="label" style="line-height: 1;" v-if="formData.category2=='Toys'">(price/case or tray with VAT)</p>
              <el-input type="number" :disabled="!canUpdate" @change="agreedPriceWithVatChange()" v-model="formData.agreedPriceWithVat"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="Per" prop="agreedPriceWithVatUnit" :rules="fpaRules1.agreedPriceWithVatUnit" style="width:100%" label-width="80px" label-position="right">
              <el-input :disabled="!canUpdate" v-model="formData.agreedPriceWithVatUnit"></el-input>
            </el-form-item>
          </el-col>
          <!-- </el-row> -->
          <!-- Agreed Price agreedPriceWithoutVat-->
          <!-- <el-row :gutter="20" v-if="formData.category2=='package-service' || formData.category2=='toy-service' || formData.category2=='Toys' || formData.category2=='logistic'"> -->
          <el-col :span="9">
            <el-form-item prop="agreedPriceWithoutVat" :rules="fpaRules1.agreedPriceWithoutVat" style="width:100%" label-width="230px">
              <p slot="label">Agreed Price</p>
              <p slot="label" style="line-height: 1;" v-if="formData.category2!='Toys'">(price/case or tray in RMB without VAT)</p>
              <p slot="label" style="line-height: 1;" v-if="formData.category2=='Toys'">(price/case or tray without VAT)</p>
              <el-input type="number" :disabled="!canUpdate" @change="agreedPriceWithoutVatChange()" v-model="formData.agreedPriceWithoutVat"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="Per" prop="agreedPriceWithoutVatUnit" :rules="fpaRules1.agreedPriceWithoutVatUnit" style="width:100%" label-width="80px" label-position="right">
              <el-input :disabled="!canUpdate" v-model="formData.agreedPriceWithoutVatUnit"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- Agreed Price agreedPriceNoVattax-->
        <el-row :gutter="20">
          <el-col :span="12" v-if="formData.category2=='planning-service'">
            <el-form-item prop="vat" :rules="fpaRules1.vat" style="width:100%" label-width="230px">
              <p slot="label">VAT Rate</p>
              <ic-select table="TM_MATERIAL_RECORD" field="URCHASE_TAX_RATE" :disabled="!canUpdate " v-model="formData.vat" @change="vatChange" style="width:100%"></ic-select>
            </el-form-item>
          </el-col>
          <!-- Estimate Volume of Purchase -->
          <el-col :span="12" v-if="formData.category2=='package-service' || formData.category2=='toy-service'|| formData.category2=='planning-service' || formData.category2=='Toys'">
            <el-form-item prop="estimateVolumeOfPurchase" :rules="fpaRules1.estimateVolumeOfPurchase" style="width:100%" label-width="230px">
              <p slot="label">Estimate Volume of Purchase</p>
              <p slot="label" style="line-height: 1;">(in unit of measurement)</p>
              <el-input type="number" :disabled="!canUpdate" @change="estimateVolumeOfPurchaseInput()" v-model="formData.estimateVolumeOfPurchase"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <!-- Cost Analysis||Risk Identification -->
      <!-- .Cost Analysis页面 Current Price without VAT和Cost Impact合并显示为一个字段：Cost Impact Vs Current Price -->
<!--      <div class="info_box">-->
        <div class="cost_analysis">
          <div class="info_box_title" style="padding-top:10px">
            <p class="line"></p>
            <p class="info_title">Cost Analysis</p>
          </div>
          <el-row :gutter="20" style="width:60.8%"><!-- <el-row :gutter="0" style="width:100%"> -->
            <el-col :span="24">
              <el-form-item style="width:100%" prop="costImpactVsCurrentPrice">
                <p slot="label">Cost Impact Vs Current Price</p>
                <el-tooltip class="item" effect="dark" content="with unit price increased/decreased% and spending amount(K RMB) excluding VAT comparison" placement="top">
                  <el-input :disabled="!canUpdate" v-model="formData.costImpactVsCurrentPrice" :title="formData.costImpactVsCurrentPrice"></el-input>
                </el-tooltip>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" style="width:60.8%"><!-- <el-row :gutter="0" style="width:100%"> -->
            <el-col :span="24">
              <el-form-item style="width:100%" prop="riskIdentifiHedgeJustifi" :rules="fpaRules1.riskIdentifiHedgeJustifi">
                <p slot="label">Risk Identification & Hedge Justification</p>
                <el-input :disabled="!canUpdate" type="textarea" :rows="5" v-model="formData.riskIdentifiHedgeJustifi" :title="formData.riskIdentifiHedgeJustifi"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
<!--        <div class="default_clause">
          <div class="info_box_title" style="padding-top:10px">
            <p class="line"></p>
            <p class="info_title">Default Clause</p>
          </div>
          <div style="height: 66%;background-color: rgb(249,188,52,0.15);padding: 10px;border-radius: 5px;font-size: 13px;">
            If Supplier fails to perform any of its obligations under this FPA (including but not limited to its delivery obligations with respect to committed quantity and committed price), Supplier shall compensate McDonald's China for all losses arising therefrom. The specific liability for breach of contract shall be governed by the terms of the Supply Agreement to be executed by both parties.
          </div>
        </div>-->
<!--      </div>-->
    </el-form>
    <el-form :model="formData" ref="formData2">
      <div class="tab_box">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane v-if="formData.category2!='logistic' && formData.category2!='planning-service'&& formData.category2!='package-service' && formData.category2!='toy-service'" label="PQCP" name="fpaPqcnTab">
            <el-row v-if="canUpdate" type="flex" justify="start">
              <el-button style="margin-right:10px" type="primary" @click="downLoadTemplate">{{$t('common.template')}}</el-button>
              <el-upload style="margin-right:10px" v-acl="updateFpaTemplate" :show-file-list="false" ref="uploadTemplate" :headers="uploadHeader" :action="templateUploadUrl" :on-success="()=>$message.success($t('common.UploadSucceed'))" multiple="false">
                <el-button type="primary">模板更新</el-button>
              </el-upload>
              <el-upload style="margin-right:10px" :show-file-list="false" ref="upload" :headers="uploadHeader" :action="fileUploadUrl" :on-success="uploadSuccess" :on-error="uploadError" :before-upload="beforeAvatarUpload" multiple>
                <el-button type="primary">{{$t("common.import")}}</el-button>
              </el-upload>
              <el-button type="primary" @click="fpaPqcnAdd">Add</el-button>
              <el-button type="danger" @click="fpaPqcnDel">Delete</el-button>
            </el-row>
            <UTable v-if="tableVisible" :data="formData.fpaPqcnList" use-virtual :big-data-checkbox="true" :height="500" ref="fpaPqcnList" border highlight-current-row max-height='500' @selection-change="handleFpaPqcnChange" style="margin-top: 10px ;" :header-cell-class-name='tableRowClassName' id="table" class="PQCP">
              <u-table-column align="center" type="selection" width="55">
              </u-table-column>
              <u-table-column align="center" label="Supplier/Facility" width="250px">
                <template slot-scope="scope">
                  <div v-if="scope.row.isNew=='N'">
                    <el-form-item class="fpaPermanentDetail" :prop=" 'fpaPqcnList.' + scope.$index + '.plantId' " :rules="{required:true,message:'Can not be Empty!',trigger: 'change'}">
                      <NOBR>
                        <el-input v-model="scope.row.facilityName" :title="scope.row.facilityName" disabled></el-input>
                        <el-input v-model="scope.row.plantId" type="hidden"></el-input>
                      </NOBR>
                    </el-form-item>
                  </div>
                  <div v-if="scope.row.isNew=='Y'">
                    <el-form-item class="fpaPermanentDetail" :prop=" 'fpaPqcnList.' + scope.$index + '.plantId' " :rules="{required:true,message:'Please select!',trigger: 'change'}">
                      <el-select v-model="scope.row.plantId" :disabled="!canUpdate" width="250px">
                        <el-option :key="index" v-for="(item,index) in fpaSupplierCoverageList" :label="item.plantName" :value="item.plantId"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </template>
              </u-table-column>
              <u-table-column align="center" label="Supplied DC" min-width="400px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" style="width:100%" :prop=" 'fpaPqcnList.' + scope.$index + '.suppliedDcArr' " :rules="{required:true,message:'Please select!',trigger: 'change'}">
                    <el-select class="multiple_sel" @change="getCurrentFreight(scope.row)" v-model="scope.row.suppliedDcArr" multiple :disabled="!canUpdate || scope.row.transportaionMethod == 'SUPPLIER'" style="width:100%">
                      <el-option :key="index" v-for="(item,index) in suppliedDcList" :label="item.dcName" :value="item.tmDcId+''"></el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </u-table-column>
              <u-table-column align="center" label="Trade Term" width="120px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaPqcnList.' + scope.$index + '.tradeTerm' " :rules="{required:true,message:'Please select!',trigger: 'change'}">
                    <!--当新物料的配送方式为直送门店或直送DC时，Trade Term只能是CIF。自提时，可以随意选择-->
                    <el-select v-model="scope.row.tradeTerm" :disabled="!canUpdate" @change="pqcpTradeTermChange(scope.row)">
                      <el-option :key="index" v-for="(item,index) in priceTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </u-table-column>
              <u-table-column v-if="canUpdate" align="center" prop="newBoolean" width="100" label="New Item">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaPqcnList.' + scope.$index + '.newBoolean' ">
                    <el-checkbox :disabled="!canUpdate" v-model="scope.row.newBoolean" @change="isNewChange(scope.row,scope.row.newBoolean)" :checked="scope.row.newBoolean" :key="scope.row.isNew"></el-checkbox>
                  </el-form-item>
                </template>
              </u-table-column>
              <u-table-column align="center" prop="localItem" label="Local Number" width="150px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaPqcnList.' + scope.$index + '.localItem' ">
                    <!-- :disabled="scope.row.isNew=='Y'||!canUpdate" -->
                    <MaterialInput v-model="scope.row.localItem" @input="inputLocalItem(scope.row)" :can-pick="scope.row.isNew=='N'" :tmSupplierId="chooseSuplierId" :disabled="true"></MaterialInput>
                  </el-form-item>
                </template>
              </u-table-column>
              <u-table-column align="center" prop="productDescription" label="Product Description" width="200px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaPqcnList.' + scope.$index + '.productDescription' " :rules="{required:true,message:'Can not be Empty!',trigger: 'change'}">
                    <el-input v-model="scope.row.productDescription" :title="scope.row.productDescription" :disabled="scope.row.isNew=='N' || !canUpdate"></el-input>
                  </el-form-item>
                </template>
              </u-table-column>
              <u-table-column align="center" prop="packingSizePerUom" label="Packing Size per SU" width="200px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaPqcnList.' + scope.$index + '.packingSizePerUom' " :rules="{required:true,message:'Can not be Empty!',trigger: 'change'}">
                    <el-input v-model="scope.row.packingSizePerUom" :title="scope.row.packingSizePerUom" :disabled="scope.row.isNew=='N' || !canUpdate"></el-input>
                  </el-form-item>
                </template>
              </u-table-column>
              <u-table-column align="center" prop="uom" :label="'Settlement Unit \n (per SU)'" width="120px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaPqcnList.' + scope.$index + '.uom' " :rules="{required:true,message:'Can not be Empty!',trigger: 'change'}">
                    <el-select v-model="scope.row.uom" :disabled="scope.row.isNew=='N' || !canUpdate">
                      <el-option :key="index" v-for="(item,index) in uomList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </u-table-column>
              <u-table-column align="center" prop="currentPricePerUom" :label="'Current Price per SU \n(Exwork,excluding VAT)'" width="175px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaPqcnList.' + scope.$index + '.currentPricePerUom' ">
                    <el-input v-model="scope.row.currentPricePerUom" :title="scope.row.currentPricePerUom" disabled></el-input>
                  </el-form-item>
                </template>
              </u-table-column>
              <u-table-column align="center" prop="newPricePerUom" :label="'New Price per SU \n(excluding VAT)'" width="130px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaPqcnList.' + scope.$index + '.newPricePerUom' " :rules="{required:true,message:'Can not be Empty!',trigger: 'change'}">
                    <el-input :disabled="!canUpdate" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g, '$1')" @change="countPqcp(scope.row)" v-model.lazy="scope.row.newPricePerUom" :title="scope.row.newPricePerUom"></el-input>
                  </el-form-item>
                </template>
              </u-table-column>
              <u-table-column align="center" prop="currency" label="Currency" width="100px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaPqcnList.' + scope.$index + '.currency' " :rules="{required:true,message:'Can not be Empty!',trigger: 'change'}">
                    <el-select v-model="scope.row.currency" disabled>
                      <el-option :key="index" v-for="(item,index) in currencyList" :label="item.value" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </u-table-column>
              <u-table-column align="center" prop="vat" label="VAT" width="90px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaPqcnList.' + scope.$index + '.vat' " :rules="{required:true,message:'Can not be Empty!',trigger: 'change'}">
                    <el-select v-model="scope.row.vat" :disabled="!canUpdate" @change="countPqcp(scope.row)">
                      <el-option :key="index" v-for="(item,index) in pqcnVatRateList" :value="item.code" :label="item | inputChoiceI18n"></el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </u-table-column>
              <u-table-column align="center" prop="transportaionMethod" label="Delivery Type" width="150px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaPqcnList.' + scope.$index + '.transportaionMethod' " :rules="{required:true,message:'Please select!',trigger: 'change'}">
                    <el-select v-model="scope.row.transportaionMethod" :disabled="!canUpdate" @change="countPqcp(scope.row),getCurrentFreight(scope.row),delivertTypeChange(scope.row.transportaionMethod,scope.row,scope.$index)">
                      <el-option :key="index" v-for="(item,index) in newTransportaionMethodList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </u-table-column>
              <u-table-column align="center" prop="currentFreight" label="Current Freight" width="150px"></u-table-column>
              <u-table-column align="center" prop="freight" label="New Freight" width="150px">
                <template slot-scope="scope">
                  <el-form-item v-if="scope.row.transportaionMethod!='DC'" class="fpaPermanentDetail" :prop=" 'fpaPqcnList.' + scope.$index + '.freight' " :rules="{required:true,message:'Can not be Empty!',trigger: 'change'}">
                    <el-input type="number" :disabled="!canUpdate" @input="scope.row.freight=utils.formatPositiveNumber(scope.row.freight,6)" @change="countPqcp(scope.row)" v-model="scope.row.freight"></el-input>
                  </el-form-item>
                  <!--配送方式选择自提，Freight框置灰不可编辑-->
                  <el-form-item v-if="scope.row.transportaionMethod=='!DC'" class="fpaPermanentDetail" :prop=" 'fpaPqcnList.' + scope.$index + '.freight' ">
                    <el-input type="number" disabled @input="scope.row.freight=utils.formatPositiveNumber(scope.row.freight,6)" @change="countPqcp(scope.row)" v-model="scope.row.freight"></el-input>
                  </el-form-item>
                </template>
              </u-table-column>
              <u-table-column align="center" prop="ddpCost" :label="'Total Cost \n(excluding VAT)'" width="120px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaPqcnList.' + scope.$index + '.ddpCost' " :rules="{required:true,message:'Can not be Empty!',trigger: 'change'}">
                    <el-input type="number" :disabled="!canUpdate" @input="scope.row.ddpCost=utils.formatPositiveNumber(scope.row.volumeEstimation,6)" @change="countPqcp(scope.row)" v-model="scope.row.ddpCost"></el-input>
                  </el-form-item>
                </template>
              </u-table-column>
              <u-table-column align="center" prop="change" label="Change" width="100px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaPqcnList.' + scope.$index + '.change' ">
                    <el-input v-model="scope.row.change" style="width:80%;" disabled></el-input> %
                  </el-form-item>
                </template>
              </u-table-column>
              <u-table-column align="center" prop="validFrom" label="Valid From(Date)" width="150px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaPqcnList.' + scope.$index + '.validFrom' " :rules="{required:true,message:'Can not be Empty!',trigger: 'change'}">
                    <el-date-picker :disabled="!canUpdate" type="date" placeholder="选择日期" v-model="scope.row.validFrom" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                  </el-form-item>
                </template>
              </u-table-column>
              <u-table-column align="center" prop="validTo" label="Valid To(Date)" width="150px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaPqcnList.' + scope.$index + '.validTo' " :rules="{required:true,message:'Can not be Empty!',trigger: 'change'}">
                    <el-date-picker :disabled="!canUpdate" type="date" placeholder="选择日期" v-model="scope.row.validTo" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                  </el-form-item>
                </template>
              </u-table-column>
              <u-table-column align="center" prop="volumeEstimation" label="Volume Estimation" width="150px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaPqcnList.' + scope.$index + '.volumeEstimation' " :rules="{required:true,message:'Can not be Empty!',trigger: 'change'}">
                    <el-input :disabled="!canUpdate" type="number" @change="countPqcp(scope.row)" @input="scope.row.volumeEstimation=utils.formatPositiveNumber(scope.row.volumeEstimation,2)" v-model="scope.row.volumeEstimation"></el-input>
                  </el-form-item>
                </template>
              </u-table-column>
              <u-table-column align="center" prop="contentPerUom" label="Content Per SU" width="180px" class="Content Per SU">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaPqcnList.' + scope.$index + '.contentPerUom' ">
                    <!--正整数-->
                    <el-input type="number" @input="scope.row.contentPerUom=utils.formatPositiveNumber(scope.row.contentPerUom,6)" @change="countPqcp(scope.row)" :disabled="!canUpdate" v-model="scope.row.contentPerUom"></el-input>
                  </el-form-item>
                </template>
              </u-table-column>
              <u-table-column align="center" prop="unit" label="Unit" width="100px" class="Unit">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaPqcnList.' + scope.$index + '.unit' ">
                    <el-select v-model="scope.row.unit" :disabled="!canUpdate">
                      <el-option :key="index" v-for="(item,index) in pqcnUnitList" :value="item.code" :label="item | inputChoiceI18n"></el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </u-table-column>
              <u-table-column align="center" prop="pricePerUnit" label="Price per Unit" width="150px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaPqcnList.' + scope.$index + '.pricePerUnit' ">
                    <el-input disabled v-model="scope.row.pricePerUnit" :title="scope.row.pricePerUnit"></el-input>
                  </el-form-item>
                </template>
              </u-table-column>
              <u-table-column align="center" prop="remark" label="Remark" width="200px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaPqcnList.' + scope.$index + '.remark' ">
                    <el-input :disabled="!canUpdate" v-model="scope.row.remark" :title="scope.row.remark"></el-input>
                  </el-form-item>
                </template>
              </u-table-column>
            </UTable>
          </el-tab-pane>
          <el-tab-pane v-if="formData.category2=='logistic'" label="PQCP" name="fpaPcnTab">
            <el-table :data="formData.fpaLogisticRates" max-height="500" ref="fpaLogisticRates" border highlight-current-row style="margin-top: 10px ;" class="campaign_table PQCP">
              <el-table-column show-overflow-tooltip align="center" prop="dcName" label="Supplied DC" min-width="150px"></el-table-column>
              <el-table-column align="center" label="Transportation">
                <el-table-column align="center" prop="transportationRate" label="New Item Rate without VAT" min-width="200px">
                  <template slot-scope="scope">
                    <el-form-item class="fpaPermanentDetail" :prop=" 'fpaLogisticRates.' + scope.$index + '.transportationRate' " :rules="transportationRateRules(scope.$index,scope.row)">
                      <el-input :disabled="!canUpdate" @change="transportationRateChange(scope.row)" v-model="scope.row.transportationRate"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="transportationRateWithVat" label="New Item Rate with VAT" show-overflow-tooltip min-width="200px">
                  <template slot-scope="scope">
                    <el-form-item class="fpaPermanentDetail" :prop=" 'fpaLogisticRates.' + scope.$index + '.transportationRateWithVat' ">
                      <span>{{scope.row.transportationRateWithVat | fix(6) }}</span>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="transportationVat" label="VAT Rate" min-width="160px">
                  <template slot-scope="scope">
                    <el-form-item class="fpaPermanentDetail" :prop=" 'fpaLogisticRates.' + scope.$index + '.transportationVat'" :rules="transportationVatRules(scope.$index,scope.row)">
                      <ic-select table="TM_MATERIAL_RECORD" field="URCHASE_TAX_RATE" :disabled="!canUpdate " v-model="scope.row.transportationVat" @change="transportationVatChange(scope.row,$event)" style="width:100%"></ic-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="transportationVatValue" label="New Item VAT Value" show-overflow-tooltip min-width="200px">
                  <template slot-scope="scope">
                    <el-form-item class="fpaPermanentDetail" :prop=" 'fpaLogisticRates.' + scope.$index + '.transportationVatValue' ">
                      <span>{{scope.row.transportationVatValue | fix(6) }}</span>
                    </el-form-item>
                  </template>
                </el-table-column>
              </el-table-column>

              <el-table-column align="center" label="Warehouse">
                <el-table-column align="center" prop="warehouseRate" label="New Item Rate without VAT" min-width="200px">
                  <template slot-scope="scope">
                    <el-form-item class="fpaPermanentDetail" :prop=" 'fpaLogisticRates.' + scope.$index + '.warehouseRate' " :rules="warehouseRateRules(scope.$index,scope.row)">
                      <el-input :disabled="!canUpdate" @change="warehouseRateChange(scope.row)" v-model="scope.row.warehouseRate"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="warehouseRateWithVat" label="New Item Rate with VAT" show-overflow-tooltip min-width="200px">
                  <template slot-scope="scope">
                    <el-form-item class="fpaPermanentDetail" :prop=" 'fpaLogisticRates.' + scope.$index + '.warehouseRateWithVat' ">
                      <span>{{scope.row.warehouseRateWithVat | fix(6) }}</span>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="warehouseVat" label="VAT Rate" min-width="160px">
                  <template slot-scope="scope">
                    <el-form-item class="fpaPermanentDetail" :prop=" 'fpaLogisticRates.' + scope.$index + '.warehouseVat' " :rules="warehouseVatRules(scope.$index,scope.row)">
                      <ic-select table="TM_MATERIAL_RECORD" field="URCHASE_TAX_RATE" :disabled="!canUpdate " v-model="scope.row.warehouseVat" @change="warehouseVatChange(scope.row,$event)" style="width:100%"></ic-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="warehouseVatValue" label="New Item VAT Value" show-overflow-tooltip min-width="200px">
                  <template slot-scope="scope">
                    <el-form-item class="fpaPermanentDetail" :prop=" 'fpaLogisticRates.' + scope.$index + '.warehouseVatValue' ">
                      <span>{{scope.row.warehouseVatValue | fix(6) }}</span>
                    </el-form-item>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column align="center" prop="adpCost" label="Total ADP Cost(without VAT)" show-overflow-tooltip min-width="200px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaLogisticRates.' + scope.$index + '.warehouseRateWithVat' ">
                    <span>{{scope.row.adpCost | fix(6) }}</span>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="adpCostWithVat" label="Total ADP Cost(with VAT)" show-overflow-tooltip min-width="200px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaLogisticRates.' + scope.$index + '.warehouseRateWithVat' ">
                    <span>{{scope.row.adpCostWithVat | fix(6) }}</span>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="currentAdpCost" label="Current ADP Cost(without VAT)" show-overflow-tooltip min-width="200px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaLogisticRates.' + scope.$index + '.warehouseRateWithVat' ">
                    <span>{{scope.row.currentAdpCost | fix(6) }}</span>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="adpChange" label="Change" show-overflow-tooltip min-width="120px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaLogisticRates.' + scope.$index + '.adpChange' ">
                    <span>{{scope.row.adpChange | percentSeparator}}</span>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="chargeUnit" label="Charge Unit" show-overflow-tooltip min-width="160px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaLogisticRates.' + scope.$index + '.chargeUnit' " :rules="{required:true,message:'Please select!',trigger: 'change'}">
                    <ic-select table="TT_FPA_LOGISTIC_RATE" field="CHARGE_UNIT" :disabled="!canUpdate " v-model="scope.row.chargeUnit" style="width:100%"></ic-select>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="estVolume" label="Volume Estimation" show-overflow-tooltip min-width="180px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaLogisticRates.' + scope.$index + '.estVolume' " :rules="estVolumeRules(scope.$index,scope.row)">
                    <el-input :disabled="!canUpdate" v-model="scope.row.estVolume" @change="estVolumeChange(scope.row)"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="totalEstimatedValue" label="Total Estimated Value(with VAT)" show-overflow-tooltip min-width="200px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaLogisticRates.' + scope.$index + '.totalEstimatedValue' ">
                    <span>{{scope.row.totalEstimatedValue | thousandSeparatorAnd}}</span>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="remark" label="Remark" show-overflow-tooltip min-width="200px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaLogisticRates.' + scope.$index + '.remark' ">
                    <el-input :disabled="!canUpdate" v-model="scope.row.remark"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane v-if="formData.category2=='planning-service'" label="PQCP" name="fpaPcnTab">
            <el-table :data="formData.fpaDcSettles" max-height="500" ref="fpaDcSettles" border highlight-current-row style="margin-top: 10px ;" class="campaign_table PQCP">
              <el-table-column show-overflow-tooltip align="center" prop="dcName" label="Supplied DC" min-width="150px"></el-table-column>
              <el-table-column align="center" prop="settleDcId" label="Settle" min-width="300px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaDcSettles.' + scope.$index + '.settleDcId' " :rules="settleDcIdRules(scope.$index,scope.row)">
                    <el-select v-model="scope.row.settleDcId" clearable :disabled="!canUpdate" placeholder="请选择" style="width:100%">
                      <el-option v-for="item in settleDcOptions" :key="item.tmDcId" :label="item.dcName" :value="item.tmDcId">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="vat" label="VAT Rate" min-width="150px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaDcSettles.' + scope.$index + '.vat' " :rules="vatRules(scope.$index,scope.row)">
                    <ic-select table="TM_MATERIAL_RECORD" field="URCHASE_TAX_RATE" :disabled="!canUpdate " v-model="scope.row.vat" style="width:100%"></ic-select>
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <!-- 2026.7 新增 Agreed Supply Quantity -->
          <el-tab-pane v-if="formData.category1 == 10" label="Agreed Supply Quantity" name="agreedSupplyQty">
            <el-row v-if="canUpdate" type="flex" justify="start">
              <el-button style="margin-right:10px" type="primary" @click="downLoadAgreedSupplyQtyTemplate">{{$t('common.template')}}</el-button>
<!--              <el-upload style="margin-right:10px" v-acl="updateFpaTemplate" :show-file-list="false" ref="uploadAgreedSupplyQtyTemplate" :headers="uploadHeader" :action="agreedSupplyQtyTemplateUploadUrl" :on-success="()=>$message.success($t('common.UploadSucceed'))" multiple="false">
                <el-button type="primary">模板更新</el-button>
              </el-upload>-->
              <el-upload style="margin-right:10px" :show-file-list="false" ref="upload" :headers="uploadHeader" :action="agreedSupplyQtyFileUploadUrl" :on-success="agreedSupplyQtyUploadSuccess" :on-error="uploadError" :before-upload="beforeAvatarUpload" multiple>
                <el-button type="primary">{{$t("common.import")}}</el-button>
              </el-upload>
              <el-button type="primary" @click="fpaAgreedSupplyQtyAdd">Add</el-button>
              <el-button type="danger" @click="fpaAgreedSupplyQtyDel">Delete</el-button>
            </el-row>
            <UTable v-if="tableVisible" :data="formData.agreedSupplyList" use-virtual :big-data-checkbox="true" :height="500" ref="agreedSupplyList" border highlight-current-row max-height='500' @selection-change="handleFpaAgreedSupplyQtyChange" style="margin-top: 10px ;" id="table2" class="PQCP">
              <u-table-column align="center" type="selection" width="55"></u-table-column>
              <u-table-column align="center" label="Time Period From" min-width="150px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop="'agreedSupplyList.' + scope.$index + '.periodFrom'" :rules="{required:true,message:'Can not be Empty!',trigger: 'change'}">
                    <el-date-picker :disabled="!canUpdate" type="date" placeholder="选择日期" v-model="scope.row.periodFrom" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                  </el-form-item>
                </template>
              </u-table-column>
              <u-table-column align="center" label="Time Period To" min-width="150px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop="'agreedSupplyList.' + scope.$index + '.periodTo'" :rules="{required:true,message:'Can not be Empty!',trigger: 'change'}">
                    <el-date-picker :disabled="!canUpdate" type="date" placeholder="选择日期" v-model="scope.row.periodTo" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                  </el-form-item>
                </template>
              </u-table-column>
              <u-table-column align="center" label="Local Number" min-width="180px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop="'agreedSupplyList.' + scope.$index + '.localItem'" :rules="{required:true,message:'Can not be Empty!',trigger: 'change'}">
                    <MaterialInput v-model="scope.row.localItem" @input="agreedSupplyQtyInputLocalItem(scope.row)" :tmSupplierId="chooseSuplierId" :disabled="true"></MaterialInput>
                  </el-form-item>
                </template>
              </u-table-column>
              <u-table-column align="center" label="Product Description" min-width="180px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop="'agreedSupplyList.' + scope.$index + '.productDescription'">
                    <el-input v-model="scope.row.productDescription" :title="scope.row.productDescription" disabled></el-input>
                  </el-form-item>
                </template>
              </u-table-column>
              <u-table-column align="center" label="Plant/Facility" min-width="150px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop="'agreedSupplyList.' + scope.$index + '.plantName'">
                    <el-input v-model="scope.row.plantName" :title="scope.row.plantName" disabled></el-input>
                  </el-form-item>
                </template>
              </u-table-column>
              <u-table-column align="center" prop="supplyQty" label="Agreed Supply Quantity" min-width="180px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop="'agreedSupplyList.' + scope.$index + '.supplyQty'" :rules="{required:true,message:'Can not be Empty!',trigger: 'change'}">
                    <el-input :disabled="!canUpdate" @input="handleInput(scope.row)" v-model="scope.row.supplyQty"></el-input>
                  </el-form-item>
<!--                  <el-form-item class="fpaPermanentDetail" :prop=" 'fpaPqcnList.' + scope.$index + '.volumeEstimation' " :rules="{required:true,message:'Can not be Empty!',trigger: 'change'}">
                    <el-input :disabled="!canUpdate" type="number" @change="countPqcp(scope.row)" @input="scope.row.volumeEstimation=utils.formatPositiveNumber(scope.row.volumeEstimation,2)" v-model="scope.row.volumeEstimation"></el-input>
                  </el-form-item>-->
                </template>
              </u-table-column>
              <u-table-column align="center" label="Unit" min-width="100px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop="'agreedSupplyList.' + scope.$index + '.unit'">
                    <el-input v-model="scope.row.unit" disabled></el-input>
                  </el-form-item>
                </template>
              </u-table-column>
              <u-table-column align="center" label="Remarks" min-width="200px">
                <template slot-scope="scope">
                  <el-form-item class="fpaPermanentDetail" :prop="'agreedSupplyList.' + scope.$index + '.remarks'">
                    <el-input :disabled="!canUpdate" v-model="scope.row.remarks" :title="scope.row.remarks"></el-input>
                  </el-form-item>
                </template>
              </u-table-column>
            </UTable>
          </el-tab-pane>
          <el-tab-pane label="Attachment" name="attachment">
            <table class="table-d">
              <tr>
                <td class="title">Type</td>
                <td class="title">Attachment</td>
              </tr>
              <tr>
                <td>System Document</td>
                <td>
                  <el-link type="warning" v-if="isPdfDownload" @click="onDownload('System Document')">Download by PDF</el-link>
                </td>
              </tr>
              <tr>
                <td>Signoff Document</td>
                <td>
                  <div v-if="canSignatureDownload">
                    <div v-for="(item,index) in files1" :key="index">
                      <el-link type="warning" @click="onDownload('Signoff Document',item)">{{item.documentName}}</el-link>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Other Document</td>
                <td>
                  <div v-if="canAttachmentDownload">
                    <div v-for="(item,index) in files2" :key="index">
                      <el-link type="warning" @click="onDownload('Other Document',item)">{{item.documentName}}</el-link>
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </el-tab-pane>
          <el-tab-pane v-if="ttFpaId > 0" label="Audit Record" name="fpaLog">
            <el-table :data="formData.auditLogList" border highlight-current-row class="table">
              <el-table-column show-overflow-tooltip sortable prop="operatorName" align="center" label="Update by"></el-table-column>
              <el-table-column show-overflow-tooltip sortable prop="createDate" label="Update Time">
                <template slot-scope="scope">
                  {{scope.row.createDate|dateFormatFilter("YYYY-MM-DD")}}
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip sortable prop="action" align="center" label="Update Log"></el-table-column>
              <el-table-column show-overflow-tooltip sortable prop="comments" align="center" label="Suggestion"></el-table-column>
              <el-table-column show-overflow-tooltip sortable prop="docs" align="center" label="Attachment">
                <template slot-scope="scope">{{scope.row.effectiveBeginDate | dateFormatFilter("YYYY-MM-DD HH:mm")}}
                  <fileList :files="scope.row.docs"></fileList>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-form>
    <!--供应商选择工厂或DC-->
    <el-dialog :visible.sync="showSelSupplierDialog" append-to-body width="80%" @close="onClose">
      <!-- :type="supplierType" :tmSupplierId="chooseSuplierId" -->
      <SelDcPlant ref="supplierSelRef" :multipleSelectionFlag="true" :params="params" @subCallMethod="selectDcPlantMethod"></SelDcPlant>
    </el-dialog>
    <!--附件-->
    <el-dialog :visible.sync="showFileUpload" append-to-body width="80%">
      <FileUpload ref="fileUploadRef" :recType="bizType" :attachmentAccept="attachmentAccept" :max-length="fileListMaxLength" :bizId="ttFpaId" :seq="fileSeq" :attachmentName="bizNo" :showFileList="true" :disabled="fileUploadDisabled" @onSuccessUpload="onSuccessUpload"></FileUpload>
    </el-dialog>
    <!--审批页面-->
    <el-dialog :visible.sync="showAuditPage" append-to-body width="25%" :title="dialogTitle" class="fpa">
      <el-form :model="formData" ref="formData">
        <el-row type="flex" justify="center">
          <el-col :span="20" :offset="2">
            <el-form-item :label="$t('fpaManage.permanent.auditRemark')" prop="auditRemark" style="width:100%" :class="dialogTitle=='Reject'?'is-required':''">
              <el-input type="textarea" :rows="3" v-model="formData.auditRemark" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-button type="primary" @click="fpaApproveConfirm">Confirm</el-button>
          <el-button type="primary" @click="showAuditPage=false">Cancel</el-button>
        </el-row>
      </el-form>
    </el-dialog>
    <!--ssCategoryLeader选择-->
    <el-dialog :visible.sync="showCategoryLeaderPage" append-to-body width="500px">
      <el-form :model="formData" ref="formData" label-width="150px" style="margin-top: 10px;">
        <el-row>
          <el-col :span="20">
            <el-form-item :label="submitTitle">
              <el-select v-model="formData.ttCategoryLeaderId">
                <el-option :key="index" v-for="(item,index) in ssCategoryLeaderList" :label="item.userName" :value="item.tmUserId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <div align="center">
            <el-button type="primary" @click="ssCategoryLeaderConfirm">Confirm</el-button>
            <el-button type="primary" @click="showCategoryLeaderPage=false">Cancel</el-button>
          </div>
        </el-row>
      </el-form>
    </el-dialog>
    <!-- reject弹窗 -->
    <el-dialog :visible.sync="showRejectPage" append-to-body width="25%" class="fpa" title="Reject">
      <el-form :model="formData" ref="formData">
        <!-- <el-row type="flex" justify="center">
          <el-col :span="16">
            <p style="height:40px;line-height:40px">{{$t('fpaManage.permanent.auditRemark')}}</p>
          </el-col>
        </el-row> -->
        <el-row type="flex" justify="center">
          <el-col :span="20" :offset="2">
            <el-form-item :label="$t('fpaManage.permanent.auditRemark')" prop="auditRemark" style="width:100%" class="is-required">
              <el-input type="textarea" :rows="3" v-model="formData.auditRemark" />
            </el-form-item>
          </el-col>
        </el-row>
        <div align="center">
          <el-button type="primary" @click="returnToSuConfirm('confirm')">Confirm</el-button>
          <el-button type="primary" @click="showRejectPage=false">Cancel</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { userService } from "@/api/user-manage/user";
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";
import fpaPermanentApi from "@/api/fpa/fpaPermanent";
import { inputChoiceService } from "@/api/common/input-choice";
import SelDcPlant from '@/components/page/fpaManage/fpaPermanent/dc-plant-sel-page';
import utils from "@/utils/commonFun";
import FileUpload from "@/components/common/fileUpload";
import fileList from "@/components/common/fileList";
import DCApi from "@/api/DC/DC";
import { fileService } from "@/api/common/file-utils";
import fpaLtoCampaignApi from "@/api/fpa/fpaLtoCampaign";
import { Message } from "element-ui";
import commonFun from "@/utils/commonFun";
import MaterialInput from "@/components/page/base-data/materialInput";
import supplierApi from "@/api/supplier/supplier";
import { uuid } from 'vue-uuid';
import { materialPriceDataApi } from "@/api/base-data/materialPriceData";
import commonConstatns from "@/constants/commonConstants";
import { Decimal } from "decimal.js";
export default {
  components: { IcSelect, SelDcPlant, FileUpload, fileList, MaterialInput },
  name: "fpaPermanentDetail",
  data() {
    const validateNotNull = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("Can not be empty"));
      } else {
        callback()
      }
    }

    return {
      settleDcOptions: [],
      params: null,
      rules: {},
      isSubmitLoading: false,
      isSubmitDisabled: false,
      isPdfDownload: false,
      isAttachmentUpload: false,
      isSignUpload: false,
      pcnpageSize: 150,
      pcnCurrentPage: 1,
      isCopy: '',
      isLto: 'N',
      showSelSupplierDialog: false,
      supplierType: 'PLANT',
      supplierIds: [],
      activeName: "fpaPqcnTab",
      rowHeight: 105,
      dialogTitle: "",
      formData: {
        operateType: '',
        ttFpaId: '',
        fpaNo: '',
        createDate: '',
        createBy: '',
        createUser: '',
        category1: '',
        category2: '',
        status: '',
        queryStatus: '',
        tmSupplierId: '',
        agreementPurpose: '',
        purchaseFrequency: '',
        agreementStartDate: '',
        agreementEndDate: '',
        productOrCommodityPurchased: '',
        agreedPriceWithVat: '',
        agreedPriceWithVatUnit: '',
        agreedPriceWithoutVat: '',
        agreedPriceWithoutVatUnit: '',
        // agreedPriceNoVattax: '',
        // agreedPriceNoVattaxUnit: '',
        // currentPriceWithoutVat: '',
        estimateVolumeOfPurchase: '',
        notionalValueOfAgreement: '',
        costImpactVsCurrentPrice: '',
        riskIdentifiHedgeJustifi: '',
        supplierCoverageTotal: '',
        supplierName: '',
        auditResult: 'Y',
        auditRemark: '',
        ttCategoryLeaderId: '',
        sourceType: '',
        bizNo: '',
        currency: "",
        fpaDcCoverageList: [],
        fpaLogisticRates: [],
        fpaDcSettles: [],
        fpaSupplierCoverageList: []
      },
      fpaRules1: {
        category1: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$msg.error(this.$t('fpaManage.permanent.Category1Check'))
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        category2: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$msg.error(this.$t('fpaManage.permanent.Category2Check'))
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        supplierName: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$msg.error(this.$t('fpaManage.permanent.supplierCheck'))
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        agreementStartDate: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$msg.error(this.$t('fpaManage.permanent.agreementStartDateCheck'))
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        agreementEndDate: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$msg.error(this.$t('fpaManage.permanent.agreementEndDateCheck'))
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        productOrCommodityPurchased: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$msg.error(this.$t('fpaManage.permanent.productOrCommodityPurchasedCheck'))
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "blur"
          }
        ],
        notionalValueOfAgreement: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$msg.error(this.$t('fpaManage.permanent.pleaseMaintainNotionalValueOfAgreement'))
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "blur"
          }
        ],
        currency: [
          {
            validator: (rule, value, callback) => {
              console.log('value', value);
              if (!value) {
                this.$msg.error('Please Maintain Currency')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        agreedPriceWithVat: [
          {
            validator: (rule, value, callback) => {
              console.log('value', value);
              if (this.formData.category2 == 'planning-service' && this.curOperation === 'Y' && !value) {
                this.$msg.error('Please Maintain Agreed Price(price/case or tray in RMB with VAT)')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "blur"
          }
        ],
        agreedPriceWithVatUnit: [
          {
            validator: (rule, value, callback) => {
              console.log('value', value);
              if (this.formData.category2 == 'planning-service' && this.curOperation === 'Y' && !value) {
                this.$msg.error('Please Maintain Per')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "blur"
          }
        ],
        agreedPriceWithoutVat: [
          {
            validator: (rule, value, callback) => {
              console.log('value', value);
              if (this.formData.category2 == 'planning-service' && this.curOperation === 'Y' && !value) {
                this.$msg.error('Please Maintain Agreed Price(price/case or tray in RMB without VAT)')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "blur"
          }
        ],
        agreedPriceWithoutVatUnit: [
          {
            validator: (rule, value, callback) => {
              console.log('value', value);
              if (this.formData.category2 == 'planning-service' && this.curOperation === 'Y' && !value) {
                this.$msg.error('Please Maintain Per')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "blur"
          }
        ],
        vat: [
          {
            validator: (rule, value, callback) => {
              console.log('value', value);
              if (this.formData.category2 == 'planning-service' && this.curOperation === 'Y' && (value === '' || value === undefined || value === 'NAN' || value === null)) {
                this.$msg.error('Please Maintain VAT Rate')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        estimateVolumeOfPurchase: [
          {
            validator: (rule, value, callback) => {
              console.log('value', value);
              if (this.formData.category2 == 'planning-service' && this.curOperation === 'Y' && !value) {
                this.$msg.error('Please Maintain Estimate Volume of Purchase')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "blur"
          }
        ]
      },
      canUpdate: false,
      canApprove: false,
      canSignatureDownload: false,
      canAttachmentDownload: false,
      isOwner: false,
      ssApprove: false,
      lmApprove: false,
      lmReApprove: false,
      hgsApprove: false,
      ssReApprove: false,
      canSupplierSign: false,
      canSsDirectorApprove: false,
      canHlmApprove: false,
      canSnrDirectorApprove: false,
      canFdApprove: false,
      canScmVpApprove: false,
      canCfoVpApprove: false,
      canCeoApprove: false,
      category1List: [],
      category2List: [],
      queryStatusList: [],
      agreementPurposeList: [],
      pcnVatRateList: [],
      pqcnVatRateList: [],
      pqcnUnitList: [],
      currencyList: [],
      fpaSupplierCoverageList: [],
      fpaSupplierCoverageSelect: [],
      fpaDcCoverageSelect: [],
      fpaPcnSelect: [],
      fpaPqcnSelect: [],
      fpaAgreedSupplyQtySelect: [],
      newTransportaionMethodList: [],
      priceTypeList: [],
      uomList: [],
      suppliedDcList: [],
      temperatureList: [],
      showFileUpload: false,
      attachmentAccept: '',
      fileListMaxLength: null,
      fileSeq: '0',
      fileUploadDisabled: false,
      showAuditPage: false,
      showRejectPage: false,
      showCategoryLeaderPage: false,
      auditPerson: localStorage.getItem("ms_username"),
      auditDate: new Date(),
      bizType: 'FPA_PERMANENT',
      bizNo: '',
      category1Code: '',
      category2Code: '',
      chooseSuplierId: null,
      ssCategoryLeaderList: [],
      tradeTermDescriptionShow: false,
      fpaPqcnList: [],
      agreedSupplyList: [],
      pickerOptionsStart: {
        // 开始时间小于结束时间
        disabledDate: time => {
          let endTime = this.formData.agreementEndDate;
          if (endTime) {
            return time.getTime() > new Date(endTime).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginTime = this.formData.agreementStartDate;
          if (beginTime) {
            return time.getTime() < new Date(beginTime).getTime() - 24 * 60 * 60 * 1000;
          }
        }
      },
      attachmentList: [],
      files1: [],
      files2: [],
      height: 500,
      tableVisible: true,
      ttFpaId: null,
      isRouterBack: false,
      tmDcIdArr: [],
      curOperation: "N",//判断当前操作是提交还是保存,
      submitTitle: "ssCategoryLeader",
      isLogisticsType: false
    };
  },
  computed: {
    notionalValueOfAgreement() {
      let sum = 0;
      for (let i = 0; i < this.formData.fpaLogisticRates.length; i++) {
        if (this.formData.fpaLogisticRates[i].totalEstimatedValue) {
          sum += Number(this.formData.fpaLogisticRates[i].totalEstimatedValue)
        }
      }
      return sum
    },
    fileUploadUrl() {
      return process.env.VUE_APP_SERVER_BASE_URL + `fpaPermanent/uploadPqcn/${this.formData.tmSupplierId}`;
    },
    templateUploadUrl() {
      return commonConstatns.fileUploadUrl + `/fpaPermanentImportTemplate/1?single=true`;
    },
    agreedSupplyQtyFileUploadUrl() {
      return process.env.VUE_APP_SERVER_BASE_URL + `fpaPermanent/uploadAgreedSupply/${this.formData.tmSupplierId}`;
    },
    agreedSupplyQtyTemplateUploadUrl() {
      return commonConstatns.fileUploadUrl + `/fpaPermanentImportTemplate/1?single=true`;
    },
    calculateData() {
      let that = ths;
      const data = {
      };
      return data;
    },
    menus() {
      return this.$store.state.main.menu;
    },
  },
  watch: {
    notionalValueOfAgreement: {
      handler(newV, oldV) {
        console.log("🚀 ~ file: newFpaDetail.vue:1075 ~ handler ~ newV:", newV)
        if (this.formData.category2 == 'logistic') {
          var notionalValueOfAgreement = this.utils.formatFloat(Number(newV), 2)
          console.log("🚀 ~ file: newFpaDetail.vue:1073 ~ handler ~ notionalValueOfAgreement:", notionalValueOfAgreement)
          notionalValueOfAgreement = this.utils.formatThousand(notionalValueOfAgreement)
          console.log("🚀 ~ file: newFpaDetail.vue:1075 ~ handler ~ notionalValueOfAgreement:", notionalValueOfAgreement)
          this.$set(this.formData, 'notionalValueOfAgreement', notionalValueOfAgreement)
        }
      },
      immediate: true
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.path === '/fpaPermanentList' || from.path === '/mydashboard' || from.path === '/mytask') {
        vm.isRouterBack = true
      } else {
        vm.isRouterBack = false
      }
    })
  },
  created() {
    this.getCategoryList();
  },
  mounted() {
    this.ttFpaId = this.$route.params.ttFpaId;
    this.isCopy = this.$route.params.isCopy;
    this.getInputChoiceValues();

    // this.getCategoryLeader();
    let that = this;
    //创建技术文件
    if (this.ttFpaId == -1 && this.isCopy == 'N') {
      this.initNew();
      this.activeName = 'fpaPqcnTab';
      this.isAttachmentUpload = true
    } else {
      this.fpaDetail().then(() => {
        if (this.isCopy == 'Y') {
          that.formData.agreedSupplyList = [];
          that.formData.fpaPqcnList.forEach(row => {
            let freight = row.freight;
            let vat = row.vat;
            that.inputLocalItemCopy(row).then(() => {
              that.$set(row, 'freight', freight);
              that.$set(row, 'vat', vat);
            });
          })
        }
        let ms_Permission = JSON.parse(localStorage.getItem("ms_Permission"));
        let isLogistics = false
        if (ms_Permission.indexOf('FpaPermanentLmApproving') !== -1) {
          isLogistics = true
        }
        let pid;
        this.category1List.forEach(category1 => {
          if (this.formData.category1 == category1.code) {
            pid = category1.tmCategoryId;
          }
        });
        fpaPermanentApi.findCategory({ categoryLevel: 2, pid: pid }, isLogistics).then((res) => {
          this.category2List = res.data;
        });
      });
    }
    this.getFileList1()
    this.getFileList2()
  },
  methods: {
    onSuccessUpload(res) {
      if (res.code === '200') {
        this.$nextTick(() => {
          this.getFileList1()
          this.getFileList2()
        })
      }
    },
    downLoadTemplate() {
      fileService.getFileList({ tsReckindId: 'fpaPermanentImportTemplate', tsRecId: 1 }).then(res => {
        if (commonFun.isEmpty(res)) {
          Message.warning("未找到模板文件！");
        }
        fileService.downloadFile(res[0]);
      });
    },
    beforeAvatarUpload(file) {
      if (!this.formData.tmSupplierId) {
        this.$my_message('请先维护供应商字段信息，谢谢。', 'error');
        return false
      } else {
        return true
      }
    },
    uploadSuccess(res) {
      console.log("GY🚀 ~ uploadSuccess ~ res:", res);
      if (res.code == '200') {
        let pqcnList = res.data;
        if (commonFun.isEmpty(this.formData.fpaPqcnList)) {
          this.formData.fpaPqcnList = [];
        }
        let currency = commonFun.isEmpty(this.formData.currency) ? 'RMB' : this.formData.currency;
        pqcnList.forEach(pqcn => {
          pqcn.currency = currency;
          //packingSizePerUom 拼接出来的字符串=外包装内含内包装数量*内包装内含UOM数量（UOM字段的单位值）
          //例如： '12*23 加仑'
          let packingSizePerUom = '';
          if (pqcn.outerPackageContainsNum) {
            packingSizePerUom += pqcn.outerPackageContainsNum;
          }
          packingSizePerUom += '*';
          if (pqcn.quantityUomInnerNum) {
            packingSizePerUom += pqcn.quantityUomInnerNum;
          }
          if (pqcn.uomValue) {
            packingSizePerUom += ' ' + pqcn.uomValue;
          }
          pqcn.packingSizePerUom = packingSizePerUom;
          pqcn.originalDeliveryType = pqcn.materialTransportationMethod;

          if (pqcn.transportaionMethod == "SUPPLIER") {
            pqcn.suppliedDcArr = ["-1"];
          } else if (pqcn.transportaionMethod != "SUPPLIER" && pqcn.suppliedDcArr != null && pqcn.suppliedDcArr.length == 1 && pqcn.suppliedDcArr[0] == "-1") {
            pqcn.suppliedDcArr = [];
          }
        })
        this.formData.fpaPqcnList.push(...pqcnList);
        this.formData.fpaPqcnList.forEach((row, index) => {
          this.$set(row, 'ttFpaPqcnId', index + 1);
          this.countPqcp(row);
        })
      }
    },
    uploadError(res) {
      var errorMsg = res.toString()
      errorMsg = errorMsg.replace("Error:", "")
      errorMsg = JSON.parse(errorMsg)
      this.$message.error(errorMsg.msg)
    },
    countPqcp(row) {
      if (commonFun.isNotEmpty(row.newPricePerUom)) {
        if (this.isNumber(row.newPricePerUom)) {
          this.$set(row, "newPricePerUom", this.utils.formatFloat(parseFloat(row.newPricePerUom), 6));
        } else {
          this.$set(row, "newPricePerUom", null);
        }
      } else {
        this.$set(row, "change", null);
        this.$set(row, 'pricePerUnit', null);
      }
      if ((commonFun.isNotEmpty(row.freight) && this.isNumber(row.freight)) || row.freight == 0) {
        this.$set(row, "freight", this.utils.formatFloat(parseFloat(row.freight), 6));
      } else {
        this.$set(row, "freight", null);
      }
      if ('DC' == row.transportaionMethod) {
        this.$set(row, "freight", null);
      }
      {
        let freight = commonFun.isEmpty(row.freight) ? 0 : row.freight
        let newPricePerUom = commonFun.isEmpty(row.newPricePerUom) ? 0 : row.newPricePerUom
        if (null != freight || null != newPricePerUom) {
          this.$set(row, "ddpCost", this.utils.formatFloat(parseFloat(newPricePerUom * 1 + freight * 1), 6));
        }
      }
      if (commonFun.isNotEmpty(row.ddpCost)) {
        if (this.isNumber(row.ddpCost)) {
          this.$set(row, "ddpCost", this.utils.formatFloat(parseFloat(row.ddpCost), 6));
        } else {
          this.$set(row, "ddpCost", null);
        }
        if (commonFun.isNotEmpty(row.currentPricePerUom)) {
          let currentFreight = commonFun.isEmpty(row.currentFreight) ? 0 : row.currentFreight;
          let change = (row.ddpCost - row.currentPricePerUom - currentFreight) / (row.currentPricePerUom * 1 + currentFreight * 1) * 100;
          this.$set(row, "change", this.utils.formatFloat(parseFloat(change), 2));
        }
      }
      if (commonFun.isNotEmpty(row.volumeEstimation)) {
        if (this.isNumber(row.volumeEstimation)) {
          this.$set(row, "volumeEstimation", this.utils.formatFloat(parseFloat(row.volumeEstimation), 2));
        } else {
          this.$set(row, "volumeEstimation", null);
        }
      }
      if (commonFun.isNotEmpty(row.contentPerUom)) {
        if (this.isNumber(row.contentPerUom)) {
          this.$set(row, "contentPerUom", this.utils.formatFloat(parseFloat(row.contentPerUom), 6));
          if (commonFun.isNotEmpty(row.newPricePerUom)) {
            if (row.contentPerUom && row.contentPerUom !== '0.000000') {
              this.$set(row, 'pricePerUnit', this.utils.formatFloat(row.newPricePerUom / row.contentPerUom, 6));
            } else {
              this.$set(row, 'pricePerUnit', null);
            }
          }
        } else {
          this.$set(row, "contentPerUom", null);
        }
      } else {
        this.$set(row, 'pricePerUnit', null);
      }

      if (commonFun.isNotEmpty(this.formData.fpaPqcnList)) {
        let notionalValueOfAgreement = 0;
        this.formData.fpaPqcnList.forEach(pqcn => {
          if (commonFun.isNotEmpty(pqcn.ddpCost) && commonFun.isNotEmpty(pqcn.volumeEstimation) && commonFun.isNotEmpty(pqcn.vat)) {
            notionalValueOfAgreement += parseFloat(pqcn.ddpCost * pqcn.volumeEstimation * (1 + pqcn.vat * 1));
            // Total Cost \n(excluding VAT)*Volume Estimation*(1+VAT)
          }
        })
        notionalValueOfAgreement = this.utils.formatFloat(Number(notionalValueOfAgreement), 2)
        this.formData.notionalValueOfAgreement = this.utils.formatThousand(notionalValueOfAgreement)
      }

      if (row.transportaionMethod == "SUPPLIER") {
        this.$set(row, "suppliedDcArr", ["-1"]);
      } else if (row.transportaionMethod != "SUPPLIER" && row.suppliedDcArr != null && row.suppliedDcArr.length == 1 && row.suppliedDcArr[0] == "-1") {
        this.$set(row, "suppliedDcArr", []);
      }

      if (row.transportaionMethod == "SUPPLIER" || row.transportaionMethod == "SUPPLIER_DC") {
        //当新物料的配送方式为直送门店或直送DC时，Trade Term只能是CIF
        this.$set(row, "tradeTerm", '10');
      } else {
        this.$set(row, "tradeTerm", '11');
      }

      let that = this;
      if (commonFun.isEmpty(row.suppliedDcArr) || commonFun.isEmpty(row.localItem)) {
        return null;
      } else {
        that.getCurrentFreight(row);
      }
    },
    // 下载agreed supply quantity模板
    downLoadAgreedSupplyQtyTemplate() {
      // fileService.getFileList({ tsReckindId: 'xxxxx', tsRecId: 1 }).then(res => {
      //   if (commonFun.isEmpty(res)) {
      //     Message.warning("未找到模板文件！");
      //   }
      //   fileService.downloadFile(res[0]);
      // });
      let request = {
        path: "/templates/download/FPA-AgreedSupply批量导入.xlsx"
      }
      fpaPermanentApi.getAgreedSupplyTemplate("/templates/download/FPA-AgreedSupply批量导入.xlsx").then(res => {
        let blob = new Blob([res]);
        let url = window.URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.href = url;
        link.download = "FPA-AgreedSupply批量导入.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
    },
    agreedSupplyQtyUploadSuccess(res) {
      console.log("GY🚀 ~ uploadSuccess ~ res:", res);
      if (res.code == '200') {
        let agreedSupplyQtyList = res.data;
        // if (commonFun.isEmpty(this.formData.agreedSupplyList)) {
        //   this.formData.agreedSupplyList = [];
        // }
        this.$set(this.formData, "agreedSupplyList", [])
        this.$nextTick(() => {
          this.formData.agreedSupplyList.push(...agreedSupplyQtyList);
          this.formData.agreedSupplyList.forEach((row, index) => {
            this.$set(row, 'ttFpaAgreedSupplyId', index + 1);
          })
        })
      }
    },
    fpaAgreedSupplyQtyAdd() {
      if (utils.isEmpty(this.formData.fpaSupplierCoverageList) && this.formData.category2 != 'Toys') {
        //请先选择工厂！
        this.$message.error(this.$t('fpaManage.permanent.pleaseChooseSupplier'))
        return false;
      }

      let index = 0;
      if (utils.isEmpty(this.formData.agreedSupplyList)) {
        this.formData.agreedSupplyList = [];
      } else {
        let ttFpaAgreedSupplyIdArr = this.formData.agreedSupplyList.map(row => row.ttFpaAgreedSupplyId);
        ttFpaAgreedSupplyIdArr = ttFpaAgreedSupplyIdArr.sort((a, b) => a - b);
        index = parseInt(ttFpaAgreedSupplyIdArr[ttFpaAgreedSupplyIdArr.length - 1]);
      }
      let fpaAgreedSupplyQty = {
        ttFpaAgreedSupplyId: index + 1,
        periodFrom: null,
        periodTo: null,
        localItem: null,
        productDescription: null,
        plantName: null,
        supplyQty: null,
        unit: "箱",
        remarks: null
      };
      this.formData.agreedSupplyList.push(fpaAgreedSupplyQty);
      this.$forceUpdate();
    },
    // 删除agreed supply quantity行
    fpaAgreedSupplyQtyDel() {
      let that = this;
      if (that.fpaAgreedSupplyQtySelect.length == 0) {
        this.$message.error(this.$t('fpaManage.permanent.pleaseChooseToDelete'))
        return false;
      }
      //您确定要删除所选记录吗？
      that.$confirm('Are you sure to delete these records?', 'Tips', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        customClass: 'colorBtn',
        cancelButtonClass: 'btn_custom_cancel',
        type: 'warning'
      }).then(() => {
        this.tableVisible = false;
        that.fpaAgreedSupplyQtySelect.forEach((val) => {
          that.formData.agreedSupplyList.forEach((allVal, index) => {
            if (val.ttFpaAgreedSupplyId == allVal.ttFpaAgreedSupplyId) {
              that.formData.agreedSupplyList.splice(index, 1);
            }
          })
        })
        //如果没有$nextTick，就不会生效，这样强制保证在下个循环来显示table
        this.$nextTick(() => {
          this.tableVisible = true;
        })
        that.fpaAgreedSupplyQtySelect.length = [];

        if (commonFun.isNotEmpty(that.formData.agreedSupplyList)) {
          let notionalValueOfAgreement = 0;
          that.formData.agreedSupplyList.forEach(agreedSupplyQty => {
            if (commonFun.isNotEmpty(agreedSupplyQty.ddpCost) && commonFun.isNotEmpty(agreedSupplyQty.volumeEstimation) && commonFun.isNotEmpty(agreedSupplyQty.vat)) {
              notionalValueOfAgreement += parseFloat(agreedSupplyQty.ddpCost * agreedSupplyQty.volumeEstimation * (1 + agreedSupplyQty.vat * 1));
            }
          })
          notionalValueOfAgreement = this.utils.formatFloat(Number(notionalValueOfAgreement), 2)
          this.formData.notionalValueOfAgreement = this.utils.formatThousand(notionalValueOfAgreement)
        } else {
          that.formData.notionalValueOfAgreement = 0;
        }
      })
    },
    handleFpaAgreedSupplyQtyChange(row) {
      this.fpaAgreedSupplyQtySelect = row;
    },
    agreedSupplyQtyInputLocalItem(row) {
      let that = this;
      if (!utils.isEmpty(row.localItem)) {
        return fpaPermanentApi.fpaMaterialSearch(row.localItem).then((res) => {
          if (res.data) {
            if (res.data.ttFpaPqcnId == -1) {
              //请输入可用物料!
              this.$message.error(this.$t('fpaManage.permanent.localItemExistCheck'))
              return false;
            }
            this.$set(row, 'plantId', res.data.plantId);
            this.$set(row, 'plantName', res.data.facilityName);
            this.$set(row, 'productDescription', res.data.productDescription);
          } else {
            Message.error(res.msg || 'Operate error');
          }
          // this.countPqcp(row);
        })
      } else {
        return new Promise(resolve => resolve());
      }

    },
    countSupplierCoverage() {
      if (commonFun.isNotEmpty(this.formData.fpaSupplierCoverageList)) {
        let supplierCoverageTotal = 0;
        this.formData.fpaSupplierCoverageList.forEach(supplierCoverage => {
          if (commonFun.isNotEmpty(supplierCoverage.coverage)) {
            supplierCoverageTotal += parseFloat(supplierCoverage.coverage);
          }
        })
        this.formData.supplierCoverageTotal = supplierCoverageTotal;
      }
    },
    countDcCoverage() {
      if (commonFun.isNotEmpty(this.formData.fpaDcCoverageList)) {
        let supplierCoverageTotal = 0;
        this.formData.fpaDcCoverageList.forEach(supplierCoverage => {
          if (commonFun.isNotEmpty(supplierCoverage.coverage)) {
            supplierCoverageTotal += parseFloat(supplierCoverage.coverage);
          }
        })
        this.formData.supplierCoverageTotal = this.utils.formatFloat(supplierCoverageTotal, 2);
      }
    },
    getCategoryList() {
      let ms_Permission = JSON.parse(localStorage.getItem("ms_Permission"));
      let isLogistics = false
      if (ms_Permission.indexOf('FpaPermanentLmApproving') !== -1) {
        isLogistics = true
      } else {
        isLogistics = false
      }
      fpaPermanentApi.findCategory({ categoryLevel: 1, status: 'effective' }, isLogistics).then((res) => {
        // if (ms_Permission.indexOf('FpaPermanentLmApproving') !== -1) {
        //   res.data.map((v, i) => {
        //     if (v.code == 'Logistic' || v.code == 'service') {
        //       this.category1List.push(v)
        //     }
        //   })
        // } else {
        //   this.category1List = res.data;
        // }
        this.category1List = res.data;
      });
    },
    changeCategory1() {
      let ms_Permission = JSON.parse(localStorage.getItem("ms_Permission"));
      let isLogistics = false
      if (ms_Permission.indexOf('FpaPermanentLmApproving') !== -1) {
        isLogistics = true
      } else {
        isLogistics = false
      }
      console.log('isLogistics :', isLogistics);
      let pid;
      this.category1List.forEach(category1 => {
        if (this.formData.category1 == category1.code) {
          pid = category1.tmCategoryId;
        }
      });
      if(this.formData.category1 != 10) {
        this.formData.agreedSupplyList = [];
        this.activeName = 'fpaPqcnTab';
      }
      this.formData.category2 = '';
      this.category2List = [];
      fpaPermanentApi.findCategory({ categoryLevel: 2, pid: pid }, isLogistics).then((res) => {
        // if (ms_Permission.indexOf('FpaPermanentLmApproving') !== -1 && this.formData.category1 == 'service') {
        //   res.data.map((v, i) => {
        //     if (v.code == 'planning-service' || v.code == 'toy-service') {
        //       this.category2List.push(v)
        //     }
        //   })
        // } else {
        //   this.category2List = res.data;
        // }
        this.category2List = res.data;
      });
      this.formData.supplierName = '';
      this.formData.productOrCommodityPurchased = '';
      this.formData.agreementStartDate = '';
      this.formData.agreementEndDate = '';
      this.formData.purchaseFrequency = 'As per actual orders';
      this.formData.currency = '';
      this.formData.notionalValueOfAgreement = '';
      this.formData.fpaSupplierCoverageList = [];
      this.formData.supplierCoverageTotal = '';
      this.formData.agreedPriceWithVat = '';
      this.formData.agreedPriceWithVatUnit = '';
      this.formData.agreedPriceWithoutVat = '';
      this.formData.agreedPriceWithoutVatUnit = '';
      this.formData.agreedPriceNoVattax = '';
      this.formData.agreedPriceNoVattaxUnit = '';
      this.formData.estimateVolumeOfPurchase = '';
      this.formData.currentPriceWithoutVat = '';
      this.formData.costImpactVsCurrentPrice = '';
      this.formData.riskIdentifiHedgeJustifi = '';
      this.formData.fpaPqcnList = [];
    },
    changeToysCurrency() {
      if (commonFun.isNotEmpty(this.formData.fpaPqcnList)) {
        let currency = this.formData.currency;
        this.formData.fpaPqcnList.forEach(pqcn => {
          pqcn.currency = currency;
        })
      }
    },
    changeCategory2(val) {
      console.log('val :', val);
      if (val) {
        this.getLogisticsType(val)
      }
      console.log("🚀 ~ file: newFpaDetail.vue:1665 ~ changeCategory2 ~ this.formData.category2 :", this.formData.category2)
      this.formData.fpaDcCoverageList = []
      if (this.formData.category2 == 'logistic') {
        this.formData.fpaLogisticRates = []
        this.activeName = 'fpaPcnTab';
        if (this.ttFpaId < 0 && this.isCopy != 'Y') {
          this.formData.agreedPriceWithVatUnit = "case"
          this.formData.agreedPriceWithoutVatUnit = "case"
        }
      } else if (this.formData.category2 == 'planning-service') {
        this.activeName = 'fpaPcnTab';
        this.formData.fpaDcSettles = []
        if (this.ttFpaId < 0 && this.isCopy != 'Y') {
          this.formData.agreedPriceWithVatUnit = "case"
          this.formData.agreedPriceWithoutVatUnit = "case"
        }
      } else if (this.formData.category2 == 'toy-service') {
        if (this.ttFpaId < 0) {
          this.activeName = 'attachment';
        } else {
          this.activeName = 'fpaLog';
        }
        if (this.ttFpaId < 0 && this.isCopy != 'Y') {
          this.formData.agreedPriceWithVatUnit = "case"
          this.formData.agreedPriceWithoutVatUnit = "case"
        }
      } else if (this.formData.category2 == 'package-service') {
        if (this.ttFpaId < 0) {
          this.activeName = 'attachment';
        } else {
          this.activeName = 'fpaLog';
        }
        if (this.ttFpaId < 0 && this.isCopy != 'Y') {
          this.formData.agreedPriceWithVatUnit = "1000pcs";
          this.formData.agreedPriceWithoutVatUnit = "1000pcs"
        }
      } else if (this.formData.category2 == 'Toys') {
        if (this.ttFpaId < 0 && this.isCopy != 'Y') {
          this.formData.agreedPriceWithVatUnit = "case"
          this.formData.agreedPriceWithoutVatUnit = "case"
        }
      } else {
        this.activeName = 'fpaPqcnTab';
        if (this.ttFpaId < 0 && this.isCopy != 'Y') {
          this.formData.notionalValueOfAgreement = null;
        }
        if (this.formData.category2 == 'Toys' && utils.isEmpty(this.formData.fpaPqcnList)) {
          //Toys 只能维护一条
          this.fpaPqcnAdd();
        }
      }
    },
    getLogisticsType(category2) {
      fpaPermanentApi.getLogisticsType(category2).then((res) => {
        console.log('getLogisticsType~res :', res);
        if (res.code == '200') {
          this.isLogisticsType = res.data
        }
      })
    },
    //下拉列表数据获取
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["TT_FPA:QUERY_STATUS"] = "TT_FPA:QUERY_STATUS";
      mapObj["TT_FPA:PURPOSE_AGREEMENT"] = "TT_FPA:PURPOSE_AGREEMENT";
      mapObj["TM_MATERIAL:DIS_TYPE"] = "TM_MATERIAL:DIS_TYPE";
      mapObj["TT_FPA_PQCN:TRANSPORTAION_METHOD"] = "TT_FPA_PQCN:TRANSPORTAION_METHOD";
      mapObj["TT_FPA_PQCN:Currency"] = "TT_FPA_PQCN:Currency";
      mapObj["COMMON:TEMPERATURE"] = "COMMON:TEMPERATURE";
      mapObj["TM_MATERIAL_RECORD:PRICE_TYPE"] = "TM_MATERIAL_RECORD:PRICE_TYPE";
      mapObj["TM_MATERIAL_RECORD:MINIMUM_ORDER_UNIT"] = "TM_MATERIAL_RECORD:MINIMUM_ORDER_UNIT";
      mapObj["TT_FPA_PCN:VAT_RATE"] = "TT_FPA_PCN:VAT_RATE";
      mapObj["TM_MATERIAL_RECORD:URCHASE_TAX_RATE"] = "TM_MATERIAL_RECORD:URCHASE_TAX_RATE";
      mapObj["TT_FPA_PQCN:UNIT"] = "TT_FPA_PQCN:UNIT";
      inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
        this.queryStatusList = res["TT_FPA:QUERY_STATUS"];
        this.agreementPurposeList = res["TT_FPA:PURPOSE_AGREEMENT"];
        this.newTransportaionMethodList = res["TT_FPA_PQCN:TRANSPORTAION_METHOD"];
        this.currencyList = res["TT_FPA_PQCN:Currency"];
        this.temperatureList = res["COMMON:TEMPERATURE"];
        this.priceTypeList = res["TM_MATERIAL_RECORD:PRICE_TYPE"];
        this.uomList = res["TM_MATERIAL_RECORD:MINIMUM_ORDER_UNIT"];
        this.pcnVatRateList = res["TT_FPA_PCN:VAT_RATE"];
        this.pqcnVatRateList = res["TM_MATERIAL_RECORD:URCHASE_TAX_RATE"];
        this.pqcnUnitList = res["TT_FPA_PQCN:UNIT"];
      });

      DCApi.listAllDc().then((res) => {
        this.suppliedDcList = res.data;
      });
    },
    getCategoryLeader() {
      this.ssCategoryLeaderList = []
      let emplFlag = localStorage.getItem("ms_emplFlag");
      if (this.submitTitle == 'Logistic Manager') {
        fpaPermanentApi.getFindLogisticManager().then((res) => {
          if (res.code == '200') {
            res.data.forEach((v) => {
              this.ssCategoryLeaderList.push({
                userName: v.name,
                tmUserId: v.tmUserId
              })
            })
            // this.ssCategoryLeaderList = res.data;
          }
        })
      } else {
        let data = {
          type: 'SS'
        }
        fpaLtoCampaignApi.getCategoryLeader(data).then(res => {
          if (res.code == '200') {
            this.ssCategoryLeaderList = res.data;
          }
        });
      }

    },
    initNew() {
      this.ttFpaId = -1;
      this.formData.ttFpaId = -1
      this.formData.fpaNo = null;
      this.formData.queryStatus = 'new';
      this.formData.status = '';
      this.formData.createUser = localStorage.getItem("ms_username");
      var newDate = new Date()
      var y, m, d, h, s, min, curDate
      y = newDate.getFullYear()
      m = newDate.getMonth() + 1 < 9 ? '0' + (newDate.getMonth() + 1) : newDate.getMonth() + 1
      d = newDate.getDate() < 9 ? '0' + newDate.getDate() : newDate.getDate()
      curDate = y + '/' + m + '/' + d
      this.formData.createDate = curDate
      if (this.ttFpaId === -1 && this.isCopy !== 'Y') {
        this.formData.agreementPurpose = 'newPrice';
        this.formData.purchaseFrequency = 'As per actual orders'
      }
      this.canUpdate = true;
      this.isOwner = true;
      this.bizNo = uuid.v1();
      this.formData.bizNo = this.bizNo;
    },
    getSettleOptions(supperSupplierId) {
      let queryCondition = {
        type: 'DC',
        supperSupplierId: supperSupplierId,
        pageSize: 999999
      }
      supplierApi.searchGroupPlant(queryCondition).then((res) => {
        console.log("🚀 ~ file: newFpaDetail.vue:1680 ~ supplierApi.searchGroupPlant ~ res:", res)
        res.resultData.forEach(item => {
          var fpaDcCoverage = {
            tmDcId: item.tmSupplierId,
            dcName: item.plantNameShort
          }
          this.settleDcOptions.push(fpaDcCoverage)
        })
      })
    },
    fpaDetail() {
      let emplFlag = localStorage.getItem("ms_emplFlag");
      this.canUpdate = false;
      this.canApprove = false;
      this.canSignatureDownload = false;
      this.canAttachmentDownload = false;
      this.isOwner = false;
      this.ssApprove = false;
      this.lmApprove = false;
      this.lmReApprove = false;
      this.hgsApprove = false;
      this.canSupplierSign = false;
      this.ssReApprove = false;
      this.canSsDirectorApprove = false;
      this.canHlmApprove = false;
      this.canSnrDirectorApprove = false;
      this.canFdApprove = false;
      this.canScmVpApprove = false;
      this.canCfoVpApprove = false;
      this.canCeoApprove = false;
      this.isPdfDownload = false
      this.isAttachmentUpload = false
      this.isSignUpload = false
      return fpaPermanentApi.fpaDetail(this.ttFpaId).then((res) => {
        console.log("🚀 ~ file: newFpaDetail.vue:1667 ~ returnfpaPermanentApi.fpaDetail ~ res:", res)
        this.formData = res.data;
        if (emplFlag == 'SUP' && this.isLogisticsType) {
          this.submitTitle = 'Logistic Manager'
        } else {
          this.submitTitle = 'ssCategoryLeader'
        }
        this.getCategoryLeader()
        this.getLogisticsType(this.formData.category2)
        if (this.formData.fpaLogisticRates.length > 0) {
          this.formData.fpaLogisticRates.forEach(ele => {
            if (ele.transportationRate) {
              this.$set(ele, 'transportationRate', ele.transportationRate.toFixed(6))
            }
            if (ele.warehouseRate) {
              this.$set(ele, 'warehouseRate', ele.warehouseRate.toFixed(6))
            }
            if (ele.estVolume) {
              this.$set(ele, 'estVolume', ele.estVolume.toFixed(2))
            }
            if (ele.totalEstimatedValue) {
              this.$set(ele, 'totalEstimatedValue', ele.totalEstimatedValue.toFixed(2))
            }
          })
        }
        this.ttFpaId = res.data.ttFpaId
        this.formData.ttFpaId = res.data.ttFpaId
        this.formData.fpaPqcnList = res.data.fpaPqcnList;
        this.formData.fpaPqcnList.forEach(ele => {
          this.$set(ele, 'originalDeliveryType', ele.transportaionMethod)
        })
        this.chooseSuplierId = res.data.tmSupplierId;
        this.getSettleOptions(res.data.tmSupplierId)
        if (this.isCopy == 'Y') {
          this.initNew();
          this.formData.lastApprover = null
          this.formData.status = null
        } else {
          this.bizNo = this.formData.fpaNo;
          let ms_roles = JSON.parse(localStorage.getItem("ms_roles"));
          let supplierObj = localStorage.getItem("supplierObj");
          let ms_Permission = JSON.parse(localStorage.getItem("ms_Permission"));
          // 仅当前创建人
          if (localStorage.getItem("ms_userId") == this.formData.createBy) {
            this.isOwner = true;
          }
          if (this.formData.status == 'toSign' && supplierObj && JSON.parse(supplierObj).supperSupplierId == this.formData.tmSupplierId && (this.formData.sourceType == 'su' || this.formData.sourceType == 'ss' || this.formData.sourceType == 'lm')) {
            this.canSupplierSign = true;
          }
          // if (this.formData.category2!='logistic'&&this.formData.category2!='planning-service') {
          this.fpaSupplierCoverageList = this.formData.fpaSupplierCoverageList;
          // }else{
          //   this.formData.fpaDcCoverageList = this.formData.fpaDcCoverageList;
          // }
          if ((this.formData.status == 'lmNew' || this.formData.status == 'ssNew' || this.formData.status == 'suNew' || this.formData.status == 'mdmNew' || this.formData.status == 'reject') && this.isOwner) {
            this.canUpdate = true;
          }
          //待ss初审
          if (this.formData.status == 'ssApproving' && localStorage.getItem("ms_userId") == this.formData.ttCategoryLeaderId) {
            this.ssApprove = true;
          }
          //待Logistic Manager初审
          if (this.formData.status == 'lmApproving' && localStorage.getItem("ms_userId") == this.formData.ttCategoryLeaderId) {
            this.lmApprove = true;
          }
          //待Logistic Manager审批
          if (this.formData.status == 'lmReApproving' && localStorage.getItem("ms_userId") == this.formData.ttCategoryLeaderId) {
            this.lmReApprove = true;
          }
          // hgs预审
          if (this.formData.status == 'suPreAudit' && ms_Permission.indexOf('FpaPermanentSuPreAudit') != -1) {
            this.hgsApprove = true;
          }
          //ssCategoryLeader再审
          if (this.formData.status == 'ssReApproving' && localStorage.getItem("ms_userId") == this.formData.ttCategoryLeaderId) {
            this.ssReApprove = true;
          }
          // Head of Logistic Management审批
          if (ms_Permission.indexOf('FpaPermanentLmDirectorApproving') != -1 && this.formData.status == 'lmDirectorApproving') {
            this.canHlmApprove = true;
          }
          //ssDirectorApproving:待ssDirector审批
          //snrDirectorApproving:待SS SNR Director审批,financeDirectorApproving:待Finance Director审批,scmVpApproving:待scm vp审批
          //CFOApproving:待CFO审批,CEOApproving:待CEO审批
          if (ms_roles.indexOf('SS_Director') != -1 && this.formData.status == 'ssDirectorApproving') {
            this.canSsDirectorApprove = true;
          } else if (ms_roles.indexOf('SS_SNR_Director') != -1 && this.formData.status == 'snrDirectorApproving') {
            this.canSnrDirectorApprove = true;
          } else if (ms_roles.indexOf('Finance_Director') != -1 && this.formData.status == 'financeDirectorApproving') {
            this.canFdApprove = true;
          } else if (ms_roles.indexOf('SCM_VP') != -1 && this.formData.status == 'scmVpApproving') {
            this.canScmVpApprove = true;
          } else if (ms_roles.indexOf('CFO') != -1 && this.formData.status == 'CFOApproving') {
            this.canCfoVpApprove = true;
          } else if (ms_roles.indexOf('CEO') != -1 && this.formData.status == 'CEOApproving') {
            this.canCeoApprove = true;
          }
        }
        // 判断pdf下载的显示与否(待SS初审/mdm检查/待供应商签字附件上传/待CategoryLeader审批/待Head of Category SS审批/待Head of Strategic Sourcing审批/待Finance Director审批/待ScmVp审批/待CFO审批/待CEO审批)
        if (this.formData.status === 'ssApproving' ||
          this.formData.status === 'mdmCheck' ||
          this.formData.status === 'toSign' ||
          this.formData.status === 'ssReApproving' ||
          this.formData.status === 'ssDirectorApproving' ||
          this.formData.status === 'snrDirectorApproving' ||
          this.formData.status === 'financeDirectorApproving' ||
          this.formData.status === 'scmVpApproving' ||
          this.formData.status === 'CFOApproving' ||
          this.formData.status === 'CEOApproving' ||
          this.formData.status === 'scFinanceApproving' ||
          this.formData.status === 'approved' ||
          this.formData.status === 'lmApproving' ||
          this.formData.status === 'lmReApproving' ||
          this.formData.status === 'lmDirectorApproving') {
          this.isPdfDownload = true
        }
        // 判断sign off下载
        if (this.formData.status === 'ssReApproving' ||
          this.formData.status === 'toSign' ||
          this.formData.status === 'ssDirectorApproving' ||
          this.formData.status === 'snrDirectorApproving' ||
          this.formData.status === 'financeDirectorApproving' ||
          this.formData.status === 'scmVpApproving' ||
          this.formData.status === 'CFOApproving' ||
          this.formData.status === 'CEOApproving' ||
          this.formData.status === 'scFinanceApproving' ||
          this.formData.status === 'approved' ||
          this.formData.status === 'lmReApproving' ||
          this.formData.status === 'lmDirectorApproving') {
          this.canSignatureDownload = true
        }
        // 判断other 下载
        if (this.formData.status === 'ssApproving' ||
          this.formData.status === 'mdmCheck' ||
          this.formData.status === 'toSign' ||
          this.formData.status === 'ssReApproving' ||
          this.formData.status === 'ssDirectorApproving' ||
          this.formData.status === 'snrDirectorApproving' ||
          this.formData.status === 'financeDirectorApproving' ||
          this.formData.status === 'scmVpApproving' ||
          this.formData.status === 'CFOApproving' ||
          this.formData.status === 'CEOApproving' ||
          this.formData.status === 'reject' ||
          this.formData.status === 'scFinanceApproving' ||
          this.formData.status === 'approved' ||
          this.formData.status === 'lmApproving' ||
          this.formData.status === 'lmReApproving' ||
          this.formData.status === 'lmDirectorApproving') {
          this.canAttachmentDownload = true
        }
        // 判断上传按钮是否存在
        if (localStorage.getItem("ms_userId") == this.formData.createBy && (this.formData.status === 'suNew' || this.formData.status === 'ssNew' || this.formData.status === 'mdmNew' || this.formData.status === 'lmNew' || this.formData.status === 'reject')) {
          this.isAttachmentUpload = true
        }
        // 判断sign off上传
        // 仅当前供应商可见
        let supplierObj = localStorage.getItem("supplierObj");
        if (supplierObj && JSON.parse(supplierObj).supperSupplierId == this.formData.tmSupplierId && this.formData.status === 'toSign') {
          this.isSignUpload = true
        }
        // this.changeCategory2();
        if (this.formData.category2 == 'logistic') {
          this.activeName = 'fpaPcnTab';
        } else if (this.formData.category2 == 'planning-service') {
          this.activeName = 'fpaPcnTab';
        } else if (this.formData.category2 == 'toy-service') {
          this.activeName = 'fpaLog';
        } else if (this.formData.category2 == 'package-service') {
          this.activeName = 'fpaLog';
        } else if (this.formData.category2 == 'Toys') {
          this.activeName = 'fpaLog';
        } else {
          this.activeName = 'fpaPqcnTab';
          if (this.formData.category2 == 'Toys' && utils.isEmpty(this.formData.fpaPqcnList)) {
            //Toys 只能维护一条
            this.fpaPqcnAdd();
          }
        }
      });
    },
    supplierChoose() {
      if (!this.formData.category2) {
        //请维护Category2
        this.$message.error(this.$t('fpaManage.permanent.Category2Check'))
        return false;
      }
      var obj = {
        chooseSuplierId: null,
        supplierType: "",
        tmDcIdArr: []
      }
      let supplierObj = localStorage.getItem("supplierObj");
      console.log("🚀 ~ file: newFpaDetail.vue:1771 ~ supplierChoose ~ supplierObj:", supplierObj)
      if (supplierObj) {
        // this.chooseSuplierId = JSON.parse(supplierObj).supperSupplierId;
        this.$set(obj, 'chooseSuplierId', JSON.parse(supplierObj).supperSupplierId)
      }
      if (this.formData.category2 == 'logistic' || this.formData.category2 == 'planning-service') {
        this.$set(obj, 'supplierType', 'DC')
      } else {
        this.$set(obj, 'supplierType', 'PLANT')
      }
      if (this.formData.fpaDcCoverageList.length > 0) {
        var tmDcIdArr = this.formData.fpaDcCoverageList.map(ele => {
          return ele.tmDcId
        })
        console.log("🚀 ~ file: newFpaDetail.vue:1796 ~ tmDcIdArr ~ tmDcIdArr:", tmDcIdArr)
        this.$set(obj, 'tmDcIdArr', tmDcIdArr)
      }
      console.log("🚀 ~ file: newFpaDetail.vue:1799 ~ supplierChoose ~ obj:", obj)
      this.params = JSON.stringify(obj)
      this.showSelSupplierDialog = true;
    },
    onClose() {
      this.params = null
      this.showSelSupplierDialog = false;
    },
    //工厂或DC选择
    selectDcPlantMethod(supList) {
      console.log("选中的DC或者工厂数据:", supList)
      //物流选择DC
      if (this.formData.category2 == 'logistic') {
        this.selectDc(supList);
      } else if (this.formData.category2 == 'planning-service') {
        this.selectSettleDc(supList);
      } else {
        this.selectPlant(supList);
      }
      this.params = null
      this.$forceUpdate();
    },
    selectDc(supList) {
      console.log("选中的DC或者工厂数据 ~ selectDc:", supList)
      var flag = supList.every(ele => {
        return ele.supperSupplierId
      })
      //按Dc选择
      if (flag) {
        console.log('selectDc~this.formData.fpaDcCoverageList原先的值是:', this.formData.fpaDcCoverageList)
        console.log('selectDc~this.formData.fpaLogisticRates:', this.formData.fpaLogisticRates)
        // 如果有新增的数据
        if (supList.length > 0) {
          this.chooseSuplierId = supList[0].supperSupplierId;
          this.formData.tmSupplierId = supList[0].supperSupplierId;
          this.formData.supplierName = supList[0].supplierName;
          console.log('this.formData.fpaDcCoverageList的长度', this.formData.fpaDcCoverageList)
          // 如果有表格数据
          if (this.formData.fpaDcCoverageList.length > 0) {
            var temp_coverage_data = [... this.formData.fpaDcCoverageList]
            var temp_settle_data = [... this.formData.fpaLogisticRates]
            var tmDcIdArr = this.formData.fpaDcCoverageList.map(ele => {
              return ele.tmDcId
            })
            console.log('selectDc~按Dc选择~tmDcIdArr:', tmDcIdArr)
            var new_tmDcIdArr = []
            supList.forEach(ele => {
              new_tmDcIdArr.push(ele.tmSupplierId)
              console.log('selectDc~按Dc选择~new_tmDcIdArr:', new_tmDcIdArr)
              if (!tmDcIdArr.includes(ele.tmSupplierId)) {
                var item = {
                  tmDcId: ele.tmSupplierId,
                  dcName: ele.plantName,
                }
                temp_coverage_data.push(JSON.parse(JSON.stringify(item)))
                var item1 = {
                  tmDcId: ele.tmSupplierId,
                  dcName: ele.plantName,
                  transportationRate: null,
                  transportationRateWithVat: null,
                  transportationVat: '0.09',
                  transportationVatValue: null,
                  warehouseRate: null,
                  warehouseRateWithVat: null,
                  warehouseVat: '0.06',
                  warehouseVatValue: null,
                  adpCost: null,
                  adpCostWithVat: null,
                  adpChange: null,
                  chargeUnit: null,
                  estVolume: null,
                  totalEstimatedValue: null,
                  remark: null,
                }
                // fpaPermanentApi.getDcCurrentAdp(ele.tmSupplierId).then(res => {
                //   console.log("selectSettleDc~按Dc选择~获取dcCurrentAdp1:", res)
                //   this.$set(item1, 'currentAdpCost', res.data)
                temp_settle_data.push(JSON.parse(JSON.stringify(item1)))
                // })
              }
            })
            console.log('selectDc~按Dc选择~temp_coverage_data', temp_coverage_data)
            console.log('selectDc~按Dc选择~temp_settle_data', temp_settle_data)
            //  如果push后的数据存在已被删除的数据,则过滤
            var filterAsl = []//存放已被删除的数据
            this.formData.fpaDcCoverageList.forEach(ele => {
              if (!new_tmDcIdArr.includes(ele.tmDcId)) {
                filterAsl.push(ele.tmDcId)
              }
            })
            console.log('selectDc~按Dc选择~判断是否存在被删除的数据', filterAsl)
            this.formData.fpaDcCoverageList = temp_coverage_data.filter(ele => {
              return !filterAsl.includes(ele.tmDcId)
            })
            console.log('selectDc~按Dc选择~最终的coverage列表数据', this.formData.fpaDcCoverageList);
            this.formData.fpaLogisticRates = temp_settle_data.filter(ele => {
              return !filterAsl.includes(ele.tmDcId)
            })
            console.log('selectDc~按Dc选择~最终的settle列表数据', this.formData.fpaLogisticRates);
            this.formData.fpaLogisticRates.forEach(async (ele) => {
              let res = await pro(ele)
              console.log("🚀 ~ file: newFpaDetail.vue:1921 ~ this.formData.fpaLogisticRates.forEach ~ res:", res)
              this.$set(ele, 'currentAdpCost', res.data)
            })
            function pro(ele) {
              return new Promise((resolve, reject) => {
                fpaPermanentApi.getDcCurrentAdp(ele.tmDcId).then(res => {
                  console.log("selectSettleDc~按Dc选择~获取dcCurrentAdp1:", res)
                  resolve(res)
                })
              })
            }
          } else {
            supList.forEach(ele => {
              var item = {
                tmDcId: ele.tmSupplierId,
                dcName: ele.plantName,
              }
              this.formData.fpaDcCoverageList.push(JSON.parse(JSON.stringify(item)))
              var item1 = {
                tmDcId: ele.tmSupplierId,
                dcName: ele.plantName,
                transportationRate: null,
                transportationRateWithVat: null,
                transportationVat: '0.09',
                transportationVatValue: null,
                warehouseRate: null,
                warehouseRateWithVat: null,
                warehouseVat: '0.06',
                warehouseVatValue: null,
                adpCost: null,
                adpCostWithVat: null,
                adpChange: null,
                chargeUnit: null,
                estVolume: null,
                totalEstimatedValue: null,
                remark: null,
              }
              // fpaPermanentApi.getDcCurrentAdp(ele.tmSupplierId).then(res => {
              //   console.log("selectSettleDc~按Dc选择~获取dcCurrentAdp2:", res)
              //   this.$set(item1, 'currentAdpCost', res.data)
              this.formData.fpaLogisticRates.push(JSON.parse(JSON.stringify(item1)))
              // })
            })
            this.formData.fpaLogisticRates.forEach(async (ele) => {
              let res = await pro(ele)
              console.log("🚀 ~ file: newFpaDetail.vue:1921 ~ this.formData.fpaLogisticRates.forEach ~ res:", res)
              this.$set(ele, 'currentAdpCost', res.data)
            })
            function pro(ele) {
              return new Promise((resolve, reject) => {
                fpaPermanentApi.getDcCurrentAdp(ele.tmDcId).then(res => {
                  console.log("selectSettleDc~按Dc选择~获取dcCurrentAdp1:", res)
                  resolve(res)
                })
              })
            }
          }
        }
      } else {
        if (supList.length > 0) {
          this.formData.fpaDcCoverageList = []
          this.formData.fpaLogisticRates = []
          // this.settleDcOptions = []
          this.chooseSuplierId = supList[0].tmSupplierId;
          this.formData.tmSupplierId = supList[0].tmSupplierId;
          this.formData.supplierName = supList[0].supplierName;
          let queryCondition = {
            type: 'DC',
            supperSupplierId: supList[0].tmSupplierId,
            pageSize: 999999
          }
          supplierApi.searchGroupPlant(queryCondition).then((res) => {
            console.log("selectDc~按Group选择~supplierApi.searchGroupPlant ~ res:", res)
            res.resultData.forEach(ele => {
              var item = {
                tmDcId: ele.tmSupplierId,
                dcName: ele.plantName
              }
              this.formData.fpaDcCoverageList.push(item);
              // this.settleDcOptions.push(item);
              var item1 = {
                tmDcId: ele.tmSupplierId,
                dcName: ele.plantName,
                transportationRate: null,
                transportationRateWithVat: null,
                transportationVat: '0.09',
                transportationVatValue: null,
                warehouseRate: null,
                warehouseRateWithVat: null,
                warehouseVat: '0.06',
                warehouseVatValue: null,
                adpCost: null,
                adpCostWithVat: null,
                adpChange: null,
                chargeUnit: null,
                estVolume: null,
                totalEstimatedValue: null,
                remark: null,
              }
              // fpaPermanentApi.getDcCurrentAdp(ele.tmSupplierId).then(res => {
              //   console.log("selectSettleDc~按Dc选择~获取dcCurrentAdp3:", res)
              //   this.$set(item1, 'currentAdpCost', res.data)
              this.formData.fpaLogisticRates.push(item1);
              // })
            });
            console.log('selectDc~按Group选择~fpaDcCoverageList', this.formData.fpaDcCoverageList)
            // console.log('selectDc~按Group选择~settleDcOptions', this.settleDcOptions)
            console.log('selectDc~按Group选择~fpaLogisticRates', this.formData.fpaLogisticRates)
            this.formData.fpaLogisticRates.forEach(async (ele) => {
              let res = await pro(ele)
              console.log("🚀 ~ file: newFpaDetail.vue:1921 ~ this.formData.fpaLogisticRates.forEach ~ res:", res)
              this.$set(ele, 'currentAdpCost', res.data)
            })
            function pro(ele) {
              return new Promise((resolve, reject) => {
                fpaPermanentApi.getDcCurrentAdp(ele.tmDcId).then(res => {
                  console.log("selectSettleDc~按Dc选择~获取dcCurrentAdp1:", res)
                  resolve(res)
                })
              })
            }
          })
        }
      }
      this.formData.supplierCoverageTotal = null;
      this.showSelSupplierDialog = false;
      this.$forceUpdate();
    },
    selectSettleDc(supList) {
      console.log("选中的DC或者工厂数据 ~ selectSettleDc:", supList)
      var flag = supList.every(ele => {
        return ele.supperSupplierId
      })
      //按Dc选择
      if (flag) {
        console.log('selectSettleDc~this.formData.fpaDcCoverageList原先的值是:', this.formData.fpaDcCoverageList)
        console.log('selectSettleDc~this.formData.fpaDcSettles:', this.formData.fpaDcSettles)
        // 如果有新增的数据
        if (supList.length > 0) {
          this.chooseSuplierId = supList[0].supperSupplierId;
          this.formData.tmSupplierId = supList[0].supperSupplierId;
          this.formData.supplierName = supList[0].supplierName;
          let queryCondition = {
            type: 'DC',
            supperSupplierId: supList[0].supperSupplierId,
            pageSize: 999999
          }
          supplierApi.searchGroupPlant(queryCondition).then((res) => {
            console.log("selectSettleDc~按Dc选择~supplierApi.searchGroupPlant ~ res:", res)
            res.resultData.forEach(ele => {
              this.settleDcOptions.push({
                tmDcId: ele.tmSupplierId,
                dcName: ele.plantNameShort
              })
            })
          })
          console.log('selectSettleDc~按Dc选择~settleDcOptions', this.settleDcOptions)
          // 如果有表格数据
          if (this.formData.fpaDcCoverageList.length > 0) {
            var temp_coverage_data = [... this.formData.fpaDcCoverageList]
            var temp_settle_data = [... this.formData.fpaDcSettles]
            var tmDcIdArr = this.formData.fpaDcCoverageList.map(ele => {
              return ele.tmDcId
            })
            console.log('selectSettleDc~按Dc选择~tmDcIdArr:', tmDcIdArr)
            var new_tmDcIdArr = []
            supList.forEach(ele => {
              new_tmDcIdArr.push(ele.tmSupplierId)
              console.log('selectSettleDc~按Dc选择~new_tmDcIdArr:', new_tmDcIdArr)
              if (!tmDcIdArr.includes(ele.tmSupplierId)) {
                var item = {
                  tmDcId: ele.tmSupplierId,
                  dcName: ele.plantName,
                }
                temp_coverage_data.push(JSON.parse(JSON.stringify(item)))
                var item1 = {
                  tmDcId: ele.tmSupplierId,
                  dcName: ele.plantName,
                  settleDcId: ele.tmSupplierId,
                  settleDcName: null,
                  vat: null,
                }
                temp_settle_data.push(JSON.parse(JSON.stringify(item1)))
              }
            })
            console.log('selectSettleDc~按Dc选择~temp_coverage_data', temp_coverage_data)
            console.log('selectSettleDc~按Dc选择~temp_settle_data', temp_settle_data)
            //  如果push后的数据存在已被删除的数据,则过滤
            var filterAsl = []//存放已被删除的数据
            this.formData.fpaDcCoverageList.forEach(ele => {
              if (!new_tmDcIdArr.includes(ele.tmDcId)) {
                filterAsl.push(ele.tmDcId)
              }
            })
            console.log('selectSettleDc~按Dc选择~判断是否存在被删除的数据', filterAsl)
            this.formData.fpaDcCoverageList = temp_coverage_data.filter(ele => {
              return !filterAsl.includes(ele.tmDcId)
            })
            console.log('selectSettleDc~按Dc选择~最终的coverage列表数据', this.formData.fpaDcCoverageList);
            this.formData.fpaDcSettles = temp_settle_data.filter(ele => {
              return !filterAsl.includes(ele.tmDcId)
            })
            console.log('selectSettleDc~按Dc选择~最终的settle列表数据', this.formData.fpaDcSettles);
          } else {
            supList.forEach(ele => {
              var item = {
                tmDcId: ele.tmSupplierId,
                dcName: ele.plantName,
              }
              this.formData.fpaDcCoverageList.push(JSON.parse(JSON.stringify(item)))
              var item1 = {
                tmDcId: ele.tmSupplierId,
                dcName: ele.plantName,
                settleDcId: ele.tmSupplierId,
                settleDcName: null,
                vat: null,
              }
              this.formData.fpaDcSettles.push(JSON.parse(JSON.stringify(item1)))
            })
          }
        }
      } else {
        if (supList.length > 0) {
          this.formData.fpaDcCoverageList = []
          this.formData.fpaDcSettles = []
          this.settleDcOptions = []
          this.chooseSuplierId = supList[0].tmSupplierId;
          this.formData.tmSupplierId = supList[0].tmSupplierId;
          this.formData.supplierName = supList[0].supplierName;
          let queryCondition = {
            type: 'DC',
            supperSupplierId: supList[0].tmSupplierId,
            pageSize: 999999
          }
          supplierApi.searchGroupPlant(queryCondition).then((res) => {
            console.log("selectSettleDc~按Group选择~supplierApi.searchGroupPlant ~ res:", res)
            res.resultData.forEach(ele => {
              var item = {
                tmDcId: ele.tmSupplierId,
                dcName: ele.plantName
              }
              this.formData.fpaDcCoverageList.push(item);
              var item2 = {
                tmDcId: ele.tmSupplierId,
                dcName: ele.plantNameShort
              }
              this.settleDcOptions.push(item2);
              var item1 = {
                tmDcId: ele.tmSupplierId,
                dcName: ele.plantName,
                settleDcId: ele.tmSupplierId,
                settleDcName: null,
                vat: null,
              }
              this.formData.fpaDcSettles.push(item1);
            });
            console.log('selectSettleDc~按Group选择~fpaDcCoverageList', this.formData.fpaDcCoverageList)
            console.log('selectSettleDc~按Group选择~settleDcOptions', this.settleDcOptions)
            console.log('selectSettleDc~按Group选择~fpaDcSettles', this.formData.fpaDcSettles)
          })
        }
      }
      this.formData.supplierCoverageTotal = null;
      this.showSelSupplierDialog = false;
      this.$forceUpdate();
    },
    selectPlant(supList) {
      let _this = this;
      let codes = new Array();
      let plantIdList = new Array();
      let fpaSupplierCoverageList = new Array();
      supList.forEach(((item) => {
        //按工厂选择
        let fpaSupplierCoverage = {};
        if (item.supperSupplierId) {
          _this.chooseSuplierId = item.supperSupplierId;
          _this.formData.tmSupplierId = item.supperSupplierId;
          fpaSupplierCoverage.plantId = item.tmSupplierId;
          fpaSupplierCoverage.plantName = item.plantName;
          plantIdList.push(item.tmSupplierId);
          codes.push(item.plantName);
          _this.formData.supplierName = item.supplierName;
          fpaSupplierCoverageList.push(fpaSupplierCoverage);
          //按group选择
        } else {
          this.formData.supplierName = item.supplierName;
          this.formData.tmSupplierId = item.tmSupplierId;
          _this.chooseSuplierId = item.tmSupplierId;
          let queryCondition = {
            type: 'PLANT',
            supperSupplierId: item.tmSupplierId,
            pageSize: 999999,
          }
          supplierApi.searchGroupPlant(queryCondition).then((res) => {
            res.resultData.forEach(dc => {
              let fpaSupplierCoverage = {};
              fpaSupplierCoverage.plantId = dc.tmSupplierId;
              fpaSupplierCoverage.plantName = dc.plantName;
              plantIdList.push(item.supperSupplierId);
              codes.push(item.supplierName);
              fpaSupplierCoverageList.push(fpaSupplierCoverage);
            });

          })
        }
      }))
      _this.formData.plantIds = plantIdList.join(",");
      _this.formData.fpaSupplierCoverageList = fpaSupplierCoverageList;
      _this.fpaSupplierCoverageList = fpaSupplierCoverageList;
      _this.formData.supplierCoverageTotal = null;
      this.showSelSupplierDialog = false;
      //pqcn列表清空
      if (this.formData.category2 != 'Toys') {
        this.formData.fpaPqcnList = [];
      }
    },
    attachmentUpload(seq) {
      this.showFileUpload = true;
      this.fileUploadDisabled = false;
      this.fileSeq = seq;
      this.fileListMaxLength = null;
      if (seq == '0') {
        this.fileListMaxLength = 1;
        this.attachmentAccept = '.pdf';
      }
    },
    attachmentDownload(seq) {
      this.showFileUpload = true;
      this.fileUploadDisabled = true;
      this.fileSeq = seq;
    },
    getFileList1() {
      let attachment = {};
      attachment.seq = '0';
      attachment.tsRecId = this.ttFpaId;
      attachment.tsReckindId = 'FPA_PERMANENT';
      attachment.attachmentName = this.bizNo;
      fileService.getFileList(attachment).then(res => {
        this.files1 = res
      });
    },
    getFileList2() {
      let attachment = {};
      attachment.seq = '1';
      attachment.tsRecId = this.ttFpaId;
      attachment.tsReckindId = 'FPA_PERMANENT';
      attachment.attachmentName = this.bizNo;
      fileService.getFileList(attachment).then(res => {
        this.files2 = res
      });
    },
    onDownload(type, item) {
      if (type === 'System Document') {
        fpaPermanentApi.fpaPdfDownload(this.ttFpaId).then(res => {
          fileService.respToFile(res, 'FpaPermanent.pdf');
        });
      } else {
        fileService.downloadFile(item);
      }
    },
    // 保存
    fpaSave() {
      this.curOperation = 'N'
      this.$refs['formData1'].validate((valid) => {
        if (valid) {
          var str = [
            {
              prop: this.formData.purchaseFrequency,
              label: "Purchase Frequency",
              format: ['validLengthThousand']
            },
            {
              prop: this.formData.productOrCommodityPurchased,
              label: "Product or Commodity Purchased",
              format: ['validLengthThousand']
            },
            {
              prop: this.formData.purchaseFrequency,
              label: "Risk Identification & Hedge Justification",
              format: ['validLengthThousand']
            },
          ]
          const h = this.$createElement
          var valid = this.utils.centralizedValid(str, h)
          console.log('校验结果', valid);
          if (!valid) {
            return false
          }
          // this.$refs['formData2'].validate((valid) => {
          // if (valid) {
          this.formData.operateType = 'save';
          fpaPermanentApi.fpaSave(this.formData).then((res) => {
            if (res.data) {
              this.isCopy = 'N';
              this.ttFpaId = res.data;
              this.fpaDetail();
              this.$message.success('保存成功')
            } else {
              Message.error(res.msg || "Operate Error");
            }
          });
          // }
          // })
        }
      });

    },
    ssCategoryLeaderConfirm() {
      if (this.formData.ttCategoryLeaderId == null) {
        //请维护选择ssCategoryLeader
        this.$message.error(this.$t('fpaManage.permanent.pleaseMaintainSSCategoryLeaderId'))
        return false;
      }
      this.showCategoryLeaderPage = false;

      this.fpaSubmitConfirm();
    },
    // 提交
    fpaSubmit() {
      this.curOperation = "Y"//判断当前操作是提交还是保存,提交时才做校验
      this.$refs['formData1'].validate((valid) => {
        if (valid) {
          var str = [
            {
              prop: this.formData.purchaseFrequency,
              label: "Purchase Frequency",
              format: ['validLengthThousand']
            },
            {
              prop: this.formData.productOrCommodityPurchased,
              label: "Product or Commodity Purchased",
              format: ['required', 'validLengthThousand']
            },
            {
              prop: this.formData.purchaseFrequency,
              label: "Risk Identification & Hedge Justification",
              format: ['validLengthThousand']
            },
          ]
          const h = this.$createElement
          var valid = this.utils.centralizedValid(str, h)
          if (!valid) {
            return false
          }
          if (this.formData.category2 == 'logistic') {
            if (this.formData.fpaDcCoverageList.length === 0 || this.formData.fpaLogisticRates.length === 0) {
              this.$message.error('请选择承运商再进行维护。')
              return false
            }
          } else if (this.formData.category2 == 'planning-service') {
            if (this.formData.fpaDcCoverageList.length === 0 || this.formData.fpaDcSettles.length === 0) {
              this.$message.error('请选择承运商再进行维护。')
              return false
            }
          }
          //请维护PQCP
          if (utils.isEmpty(this.formData.fpaPqcnList)) {
            this.$message.error("请维护PQCP的数据")
            return false;
          }
          this.$refs['formData2'].validate((valid) => {
            if (valid) {
              var rrr = this.checkData()
              if (rrr) {
                this.checkDeliveryType(this.formData).then((res) => {
                  console.log("GY🚀 ~ this.checkDeliveryType ~ res:", res);
                  if (res) {
                    this.$confirm(res, {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      dangerouslyUseHTMLString: true,
                      type: 'warning'
                    }).then(() => {
                      let emplFlag = localStorage.getItem("ms_emplFlag");
                      if (emplFlag == 'SUP') {
                        this.showCategoryLeaderPage = true;
                        if (emplFlag == 'SUP' && this.isLogisticsType) {
                          this.submitTitle = 'Logistic Manager'
                        } else {
                          this.submitTitle = 'ssCategoryLeader'
                        }
                        this.getCategoryLeader()
                      } else {
                        this.formData.ttCategoryLeaderId = localStorage.getItem("ms_userId");
                        this.fpaSubmitConfirm();
                      }
                    })
                  } else {
                    let emplFlag = localStorage.getItem("ms_emplFlag");
                    if (emplFlag == 'SUP') {
                      this.showCategoryLeaderPage = true;
                      if (emplFlag == 'SUP' && this.isLogisticsType) {
                        this.submitTitle = 'Logistic Manager'
                      } else {
                        this.submitTitle = 'ssCategoryLeader'
                      }
                      this.getCategoryLeader()
                    } else {
                      this.formData.ttCategoryLeaderId = localStorage.getItem("ms_userId");
                      this.fpaSubmitConfirm();
                    }
                  }
                })
              }
            } else {
              // 请维护 Agreed Supply Quantity
              if(this.formData.agreedSupplyList && this.formData.agreedSupplyList.length> 0) {
                let valid = true;
                this.formData.agreedSupplyList.forEach(item => {
                  if(!item.periodFrom||!item.periodTo||!item.localItem||!item.supplyQty) {
                    valid = false;
                  }
                })
                if(!valid) {
                  this.$message.error("Agreed Supply Quantity TAB页面下有必填字段未填写")
                  return false;
                } else {
                  this.$message.error("PQCP TAB页面下有必填字段未填写")
                  return false;
                }
              } else {
                this.$message.error("PQCP TAB页面下有必填字段未填写")
                return false;
              }
            }
          })
        }
      })
    },
    checkDeliveryType(formData) {
      return new Promise((resolve) => {
        var errorMsg = []
        var msg = ''
        fpaPermanentApi.fpaCheckType(formData).then((res) => {
          console.log("GY🚀 ~ fpaPermanentApi.fpaCheckType ~ res:", res);
          if (res.code == '200') {
            res.data.forEach(ele => {
              if ((ele.transportaionMethod == 'DC' || ele.transportaionMethod == 'SUPPLIER_DC') && ele.materialTransportationMethod == 'SUPPLIER') {
                var str = `<p><span>物料</span>${ele.localItem}<span>的配送类型为直送门店，但维护却是非直送门店，请确认是否为业务变更？如确认变更，请点击确认，如需修改，请点击取消。</span></p><br/>`
                errorMsg.push(str)
              } else if ((ele.materialTransportationMethod == 'DC' || ele.materialTransportationMethod == 'SUPPLIER_DC' || ele.materialTransportationMethod == 'DC_SUPPLIER_DC') && ele.transportaionMethod == "SUPPLIER") {
                var str = `<p><span>物料</span>${ele.localItem}<span>配送类型为非直送门店，但维护的却是直送门店，请确认是否为业务变更？如确认变更，请点击确认，如需修改，请点击取消。</span></p><br/>`
                errorMsg.push(str)
              }
            })
            console.log("GY🚀 ~ checkDeliveryType ~ errorMsg:", errorMsg);
            if (errorMsg.length > 0) {
              msg = errorMsg.join('\n')
              console.log("GY🚀 ~ checkDeliveryType ~ msg:", msg);
            }
            resolve(msg);
          }
        });
      });

    },
    fpaSubmitConfirm() {
      this.formData.operateType = 'submit';
      //您确定要提交吗？
      this.$confirm("Would you like to submit this document!", "Tips", {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        customClass: 'colorBtn',
        cancelButtonClass: 'btn_custom_cancel',
        type: 'warning'
      }).then(() => {
        fpaPermanentApi.fpaSave(this.formData).then((res) => {
          this.curOperation = 'N'
          this.finishRouterBack(res);
        });
      })
    },
    agreedPriceWithoutVatChange() {
      if (this.isNumber(this.formData.agreedPriceWithoutVat)) {
        this.formData.agreedPriceWithoutVat = this.utils.formatFloat(parseFloat(this.formData.agreedPriceWithoutVat), 6);
        if (this.formData.category2 == 'package-service' || this.formData.category2 == 'toy-service') {
          this.formData.agreedPriceWithVat = this.utils.formatFloat((this.formData.agreedPriceWithoutVat * 1.06), 6);
          if (this.formData.agreedPriceWithVat && this.formData.estimateVolumeOfPurchase) {
            let estimateVolumeOfPurchase = parseFloat(this.formData.agreedPriceWithVat) * parseFloat(this.formData.estimateVolumeOfPurchase);
            estimateVolumeOfPurchase = this.utils.formatFloat(Number(estimateVolumeOfPurchase), 2)
            this.formData.notionalValueOfAgreement = this.utils.formatThousand(estimateVolumeOfPurchase)
          }
        } else if (this.formData.category2 == 'planning-service') {
          console.log("🚀 ~ file: newFpaDetail.vue:2237 ~ agreedPriceWithoutVatChange ~ this.formData.vat:", this.formData.vat)
          this.formData.agreedPriceWithVat = this.utils.formatFloat((this.formData.agreedPriceWithoutVat * (1 + parseFloat(this.formData.vat))), 6);
          console.log("🚀 ~ file: newFpaDetail.vue:2238 ~ agreedPriceWithoutVatChange ~ this.formData.agreedPriceWithVat:", this.formData.agreedPriceWithVat)
          if (this.formData.agreedPriceWithVat && this.formData.estimateVolumeOfPurchase) {
            let estimateVolumeOfPurchase = parseFloat(this.formData.agreedPriceWithVat) * parseFloat(this.formData.estimateVolumeOfPurchase);
            estimateVolumeOfPurchase = this.utils.formatFloat(Number(estimateVolumeOfPurchase), 2)
            console.log("🚀 ~ file: newFpaDetail.vue:2241 ~ agreedPriceWithoutVatChange ~ estimateVolumeOfPurchase:", estimateVolumeOfPurchase)
            this.formData.notionalValueOfAgreement = this.utils.formatThousand(estimateVolumeOfPurchase)
            console.log("🚀 ~ file: newFpaDetail.vue:2242 ~ agreedPriceWithoutVatChange ~ this.formData.notionalValueOfAgreement:", this.formData.notionalValueOfAgreement)
          }
        }
      } else {
        this.formData.agreedPriceWithoutVat = null;
      }
    },
    agreedPriceWithVatChange() {
      if (this.isNumber(this.formData.agreedPriceWithVat)) {
        this.formData.agreedPriceWithVat = this.utils.formatFloat(parseFloat(this.formData.agreedPriceWithVat), 6);
      } else {
        this.formData.agreedPriceWithVat = null;
      }
      if (this.formData.category2 == 'package-service' || this.formData.category2 == 'toy-service' || this.formData.category2 == 'planning-service') {
        if (this.formData.agreedPriceWithVat && this.formData.estimateVolumeOfPurchase) {
          let estimateVolumeOfPurchase = parseFloat(this.formData.agreedPriceWithVat) * parseFloat(this.formData.estimateVolumeOfPurchase);
          estimateVolumeOfPurchase = this.utils.formatFloat(Number(estimateVolumeOfPurchase), 2)
          console.log("🚀 ~ file: newFpaDetail.vue:2235 ~ agreedPriceWithVatChange ~ estimateVolumeOfPurchase:", estimateVolumeOfPurchase)
          this.formData.notionalValueOfAgreement = this.utils.formatThousand(estimateVolumeOfPurchase)
        }
      }
    },
    estimateVolumeOfPurchaseInput() {
      if (this.formData.category2 == 'package-service' || this.formData.category2 == 'toy-service' || this.formData.category2 == 'planning-service') {
        if (this.formData.agreedPriceWithVat && this.formData.estimateVolumeOfPurchase) {
          console.log("🚀 ~ file: newFpaDetail.vue:2233 ~ estimateVolumeOfPurchaseInput ~ this.formData.estimateVolumeOfPurchase:", this.formData.estimateVolumeOfPurchase)
          console.log("🚀 ~ file: newFpaDetail.vue:2233 ~ estimateVolumeOfPurchaseInput ~ this.formData.agreedPriceWithVat:", this.formData.agreedPriceWithVat)
          let estimateVolumeOfPurchase = parseFloat(this.formData.agreedPriceWithVat) * parseFloat(this.formData.estimateVolumeOfPurchase);
          console.log("🚀 ~ file: newFpaDetail.vue:2236 ~ estimateVolumeOfPurchaseInput ~ estimateVolumeOfPurchase:", estimateVolumeOfPurchase)
          estimateVolumeOfPurchase = this.utils.formatFloat(Number(estimateVolumeOfPurchase), 2)
          this.formData.notionalValueOfAgreement = this.utils.formatThousand(estimateVolumeOfPurchase)
        }
      }
    },
    checkData() {
      if ((this.formData.category2 == 'package-service' || this.formData.category2 == 'toy-service' || this.formData.category2 == 'logistic' || this.formData.category2 == 'planning-service')) {
        if (this.formData.category2 == 'logistic') {
          if (utils.isEmpty(this.formData.fpaDcCoverageList)) {
            //DC列表不能为空
            this.$message.error(this.$t('fpaManage.permanent.dcListCheck'));
            return false;
          }
        }
        //请维护Notional Value Of Agreement
        if (!this.formData.notionalValueOfAgreement) {
          this.$message.error(this.$t('fpaManage.permanent.pleaseMaintainNotionalValueOfAgreement'))
          return false;
        }
      } else {
        let errorMsg = "";
        let row = null;
        let priceErr = "";
        let transportaionMethodErr = "";
        let suppliedDcErr = "";
        let materialMap = {};
        this.formData.fpaPqcnList.forEach((pqcn, index) => {
          if (new Date(pqcn.validFrom).getTime() > new Date(pqcn.validTo).getTime()) {
            errorMsg += (parseInt(index) + 1) + ',';
            return false;
          }
          if (materialMap[pqcn.localItem] == null) {
            materialMap[pqcn.localItem] = {
              suppliedDcArr: pqcn.suppliedDcArr,
              newPricePerUom: pqcn.newPricePerUom,
              validFrom: pqcn.validFrom,
              transportaionMethod: [pqcn.transportaionMethod],
            };
          } else {
            let sumData = materialMap[pqcn.localItem];
            console.log("🚀 ~ file: newFpaDetail.vue:2047 ~ this.formData.fpaPqcnList.forEach ~ sumData:", sumData)
            let suppliedDcArr = sumData.suppliedDcArr;
            let transportaionMethod = sumData.transportaionMethod;
            if (commonFun.isNotEmpty(sumData)) {
              let tempSuppliedDcArr = new Set(pqcn.suppliedDcArr)
              let intersection = suppliedDcArr.filter(item => tempSuppliedDcArr.has(item));
              if (intersection.length > 0) {
                suppliedDcErr = "Local item :" + pqcn.localItem + this.$t('fpaManage.permanent.suppliedDcSameCheck');
                return false;
              } else {
                sumData.suppliedDcArr = Array.from(new Set([...suppliedDcArr, ...intersection]));
              }
              if (pqcn.newPricePerUom != sumData.newPricePerUom) {
                //出厂价不一致
                priceErr = "Local item :" + pqcn.localItem + this.$t('fpaManage.permanent.newPricePerUomSameCheck');
                return false;
              }
              if (pqcn.validFrom != sumData.validFrom) {
                //相同物料的开始日期必须相同
                priceErr = "Local item :" + pqcn.localItem + this.$t('fpaManage.permanent.validDateFromSameCheck');
                return false;
              }
              sumData.transportaionMethod = Array.from(new Set([pqcn.transportaionMethod, ...sumData.transportaionMethod]))
              if (sumData.transportaionMethod.length > 1 && sumData.transportaionMethod.indexOf("SUPPLIER") >= 0) {
                //配送方式不一致
                transportaionMethodErr = "Local item :" + pqcn.localItem + this.$t('fpaManage.permanent.transportaionMethodSameCheck');
                return false;
              }
            }
          }

        })
        // valid Date 开始时间要早于结束时间
        if (errorMsg) {
          this.$message.error("PQCP: " + this.$t('fpaManage.permanent.no') + errorMsg.slice(0, errorMsg.length - 1) + this.$t('fpaManage.permanent.validDateCheck'))
          return false;
        }
        if (priceErr) {
          this.$message.error(priceErr);
          return false;
        }
        if (transportaionMethodErr) {
          this.$message.error(transportaionMethodErr);
          return false;
        }
        if (suppliedDcErr) {
          this.$message.error(suppliedDcErr);
          return false;
        }

      }
      return true;
    },
    suSignSubmit() {
      this.formData.operateType = 'suSignSubmit';
      //您确定要提交吗？
      this.$confirm('Would you like to submit this document!', "Tips", {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        customClass: 'colorBtn',
        cancelButtonClass: 'btn_custom_cancel',
        type: 'warning'
      }).then(() => {
        fpaPermanentApi.suSignSubmit(this.formData).then((res) => {
          this.finishRouterBack(res);
        });
      })
    },
    returnToSuConfirm() {
      if (utils.isEmpty(this.formData.auditRemark)) {
        //退回时备注不能为空
        this.$message.error(this.$t('fpaManage.permanent.pleaseInputAuditRemark'))
        return false;
      }
      this.showRejectPage = false;
      this.formData.operateType = 'return';
      //您确定要退回吗？
      this.$confirm("Please confirm whether to return!", "Tips", {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        customClass: 'colorBtn',
        cancelButtonClass: 'btn_custom_cancel',
        type: 'warning'
      }).then(() => {
        fpaPermanentApi.returnToSu(this.formData).then((res) => {
          this.finishRouterBack(res);
        });
      })
    },
    fpaApprove(operateType) {
      if ("approving" == operateType) {
        this.dialogTitle = 'Approve'
        this.formData.auditResult = 'Y'
        this.showAuditPage = true;
      } else if ("reject" == operateType) {
        this.dialogTitle = 'Reject'
        this.formData.auditResult = 'N'
        this.showAuditPage = true;
      }
    },
    fpaApproveConfirm() {
      this.formData.operateType = 'confirm';
      if (this.formData.auditResult == 'N' && utils.isEmpty(this.formData.auditRemark)) {
        //退回时备注不能为空
        this.$message.error(this.$t('fpaManage.permanent.pleaseInputAuditRemark'))
        return false;
      }
      //您确定要提交吗？
      this.$confirm("Would you like to submit this document!", "Tips", {
        cancelButtonText: "Cancel",
        confirmButtonText: "Confirm",
        customClass: 'colorBtn',
        cancelButtonClass: 'btn_custom_cancel',
        type: 'warning'
      }).then(() => {
        // mdm审核
        if (this.formData.status == "mdmCheck") {
          fpaPermanentApi.audit(this.formData).then((res) => {
            this.finishRouterBack(res);
          });
        }
        //待SS初审
        if (this.formData.status == 'ssApproving') {
          fpaPermanentApi.ssApproving(this.formData).then((res) => {
            this.finishRouterBack(res);
          });
          //待ssCategoryLeader审批
        } else if (this.formData.status == 'ssReApproving') {
          fpaPermanentApi.ssReApproving(this.formData).then((res) => {
            this.finishRouterBack(res);
          });
          //待ssDirector审批
        } else if (this.formData.status == 'ssDirectorApproving') {
          fpaPermanentApi.ssDirectorApproving(this.formData).then((res) => {
            this.finishRouterBack(res);
          });
          //待SS SNR Director审批
        } else if (this.formData.status == 'snrDirectorApproving') {
          fpaPermanentApi.snrDirectorApproving(this.formData).then((res) => {
            this.finishRouterBack(res);
          });
          //待Finance Director审批
        } else if (this.formData.status == 'financeDirectorApproving') {
          fpaPermanentApi.fdApproving(this.formData).then((res) => {
            this.finishRouterBack(res);
          });
          // 待scm vp审批
        } else if (this.formData.status == 'scmVpApproving') {
          fpaPermanentApi.scmVpApproving(this.formData).then((res) => {
            this.finishRouterBack(res);
          });
          // 待CFO审批
        } else if (this.formData.status == 'CFOApproving') {
          fpaPermanentApi.cfoApproving(this.formData).then((res) => {
            this.finishRouterBack(res);
          });
          // 待CEO审批
        } else if (this.formData.status == 'CEOApproving') {
          fpaPermanentApi.ceoApproving(this.formData).then((res) => {
            this.finishRouterBack(res);
          });
          // hgs审批
        } else if (this.formData.status == 'suPreAudit') {
          fpaPermanentApi.hgsApproving(this.formData).then((res) => {
            this.finishRouterBack(res);
          });
          // sc finance
        } else if (this.formData.status == 'scFinanceApproving') {
          fpaPermanentApi.scFinanceApproving(this.formData).then((res) => {
            this.finishRouterBack(res);
          });
        }   //待Logistic Manager审批
        else if (this.formData.status == 'lmApproving') {
          fpaPermanentApi.lmApproving(this.formData).then((res) => {
            this.finishRouterBack(res);
          });
        }  //待Logistic Manager审批
        else if (this.formData.status == 'lmReApproving') {
          fpaPermanentApi.lmReApproving(this.formData).then((res) => {
            this.finishRouterBack(res);
          });
        } //待Head of Logistic Management审批
        else if (this.formData.status == 'lmDirectorApproving') {
          fpaPermanentApi.lmDirectorApproving(this.formData).then((res) => {
            this.finishRouterBack(res);
          });
        }
        this.showAuditPage = false;
      })
    },
    //SupplierCoverageList选择操作
    handleSupplierCoverageChange(row) {
      this.fpaSupplierCoverageSelect = row;
    },
    handleDcCoverageChange(row) {
      this.fpaDcCoverageSelect = row;
    },
    fpaSupplierCoverageDel() {
      let that = this;
      if (that.fpaSupplierCoverageSelect.length == 0) {
        //请选择需要删除的记录！
        this.$message.error(this.$t('fpaManage.permanent.pleaseChooseToDelete'))
        return false;
      }
      //您确定要删除所选记录吗？
      that.$confirm('Are you sure to delete these records?', 'Tips', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        customClass: 'colorBtn',
        cancelButtonClass: 'btn_custom_cancel',
        type: 'warning'
      }).then(() => {
        that.fpaSupplierCoverageSelect.forEach((val) => {
          that.formData.fpaSupplierCoverageList.forEach((allVal, index) => {
            // plantId 是每一行的工厂Id
            if (val.plantId == allVal.plantId) {
              that.formData.fpaSupplierCoverageList.splice(index, 1);
            }
          })
        })
        this.fpaSupplierCoverageList = that.formData.fpaSupplierCoverageList;
      })
    },
    fpaDcCoverageDel() {
      let that = this;
      if (that.fpaDcCoverageSelect.length == 0) {
        //请选择需要删除的记录！
        this.$message.error(this.$t('fpaManage.permanent.pleaseChooseToDelete'))
        return false;
      }
      //您确定要删除所选记录吗？
      that.$confirm('Are you sure to delete these records?', 'Tips', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        customClass: 'colorBtn',
        cancelButtonClass: 'btn_custom_cancel',
        type: 'warning'
      }).then(() => {
        that.fpaDcCoverageSelect.forEach((val) => {
          that.formData.fpaDcCoverageList.forEach((allVal, index) => {
            // tmDcId 是每一行的dcId
            if (val.tmDcId == allVal.tmDcId) {
              that.formData.fpaDcCoverageList.splice(index, 1);
            }
          })
        })
      })
    },
    transportationRateRules(index, row) {
      return (this.rules["transportationRate"] = [
        {
          validator: (rule, value, callback) => {
            console.log('value', value);
            console.log('row', row.transportationRate);
            // 验证不为空
            if (!row.transportationRate) {
              if (this.curOperation === 'Y') {
                this.$msg.error(row.dcName + '未维护PQCP，请检查！')
              }
              return callback(new Error('Can not be Empty!'));
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    transportationVatRules(index, row) {
      return (this.rules["transportationVat"] = [
        {
          validator: (rule, value, callback) => {
            console.log('value', value);
            console.log('row', row.transportationVat);
            // 验证不为空
            if (row.transportationVat === '' || row.transportationVat === undefined || row.transportationVat === 'NAN' || row.transportationVat === null) {
              if (this.curOperation === 'Y') {
                this.$msg.error(row.dcName + '未维护PQCP，请检查！')
              }
              return callback(new Error('Can not be Empty!'));
            }
            callback();
          },
          trigger: "change"
        }
      ]);
    },
    warehouseVatRules(index, row) {
      return (this.rules["warehouseVat"] = [
        {
          validator: (rule, value, callback) => {
            console.log('value', value);
            console.log('row', row.warehouseVat);
            // 验证不为空
            if (row.warehouseVat === '' || row.warehouseVat === undefined || row.warehouseVat === 'NAN' || row.warehouseVat === null) {
              if (this.curOperation === 'Y') {
                this.$msg.error(row.dcName + '未维护PQCP，请检查！')
              }
              return callback(new Error('Can not be Empty!'));
            }
            callback();
          },
          trigger: "change"
        }
      ]);
    },
    warehouseRateRules(index, row) {
      return (this.rules["warehouseRate"] = [
        {
          validator: (rule, value, callback) => {
            console.log('value', value);
            console.log('row', row.warehouseRate);
            // 验证不为空
            if (!row.warehouseRate) {
              if (this.curOperation === 'Y') {
                this.$msg.error(row.dcName + '未维护PQCP，请检查！')
              }
              return callback(new Error('Can not be Empty!'));
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    estVolumeRules(index, row) {
      return (this.rules["estVolume"] = [
        {
          validator: (rule, value, callback) => {
            console.log('value', value);
            console.log('row', row.estVolume);
            // 验证不为空
            if (!row.estVolume) {
              if (this.curOperation === 'Y') {
                this.$msg.error(row.dcName + '未维护PQCP，请检查！')
              }
              return callback(new Error('Can not be Empty!'));
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    settleDcIdRules(index, row) {
      return (this.rules["settleDcId"] = [
        {
          validator: (rule, value, callback) => {
            console.log('value', value);
            console.log('row', row);
            // 验证不为空
            if (!value) {
              if (this.curOperation === 'Y') {
                this.$msg.error(row.dcName + '未维护PQCP，请检查！')
              }
              return callback(new Error('Can not be Empty!'));
            }
            callback();
          },
          trigger: "change"
        }
      ]);
    },
    vatRules(index, row) {
      return (this.rules["vat"] = [
        {
          validator: (rule, value, callback) => {
            console.log('value', value);
            console.log('row', row);
            // 验证不为空
            if ((value === '' || value === undefined || value === 'NAN' || value === null)) {
              if (this.curOperation === 'Y') {
                this.$msg.error(row.dcName + '未维护PQCP，请检查！')
              }
              return callback(new Error('Can not be Empty!'));
            }
            callback();
          },
          trigger: "change"
        }
      ]);
    },
    vatChange(e) {
      console.log("🚀 ~ file: newFpaDetail.vue:2689 ~ vatChange ~ e:", e)
      this.formData.fpaDcSettles.forEach(ele => {
        this.$set(ele, 'vat', e)
      })
      if (e && this.formData.agreedPriceWithoutVat) {
        this.formData.agreedPriceWithVat = this.utils.formatFloat((this.formData.agreedPriceWithoutVat * (1 + parseFloat(e))), 6);
        console.log("🚀 ~ file: newFpaDetail.vue:2706 ~ vatChange ~ this.formData.agreedPriceWithVat:", this.formData.agreedPriceWithVat)
        if (this.formData.agreedPriceWithVat && this.formData.estimateVolumeOfPurchase) {
          let estimateVolumeOfPurchase = parseFloat(this.formData.agreedPriceWithVat) * parseFloat(this.formData.estimateVolumeOfPurchase);
          estimateVolumeOfPurchase = this.utils.formatFloat(Number(estimateVolumeOfPurchase), 2)
          console.log("🚀 ~ file: newFpaDetail.vue:2710 ~ vatChange ~ estimateVolumeOfPurchase:", estimateVolumeOfPurchase)
          this.formData.notionalValueOfAgreement = this.utils.formatThousand(estimateVolumeOfPurchase)
          console.log("🚀 ~ file: newFpaDetail.vue:2712 ~ vatChange ~ this.formData.notionalValueOfAgreement:", this.formData.notionalValueOfAgreement)
        }
      }
    },
    // Transportation -> New Item Rate without VAT值变化
    transportationRateChange(row) {
      console.log("🚀 ~ file: newFpaDetail.vue:2481 ~ transportationRateChange ~ row:", row)
      if (commonFun.isNotEmpty(row.transportationRate)) {
        let reg = /^\d+(\.\d+)?$/
        if (!reg.test(row.transportationRate)) {
          this.$set(row, "transportationRate", '');
        } else {
          this.$set(row, "transportationRate", (row.transportationRate * 1).toFixed(6));
        }

        if (commonFun.isNotEmpty(row.transportationVat)) {
          // New Item Rate with VAT=New Item Rate without VAT*(1+VAT Rate)
          var num1 = 1 + Number(row.transportationVat)
          console.log("Transportation ~ num1:", num1)
          var transportationRateWithVat = this.utils.mul(row.transportationRate, num1, 6)
          console.log("Transportation ~ New Item Rate with VAT:", transportationRateWithVat)
          this.$set(row, 'transportationRateWithVat', transportationRateWithVat)
          // New Item VAT Value=New Item Rate without VAT*VAT Rate
          // var num2 = Number(row.transportationRate) * Number(row.transportationVat)
          // console.log("Transportation ~ num2:", num2)
          var transportationVatValue = this.utils.mul(row.transportationRate, row.transportationVat, 6)
          console.log("Transportation ~ New Item VAT Value:", transportationVatValue)
          this.$set(row, 'transportationVatValue', transportationVatValue)
        } else {
          this.$set(row, 'transportationRateWithVat', null)
          this.$set(row, 'transportationVatValue', null)
        }

        // Total ADP Cost(without VAT)=New Item Rate without VAT(Transportation+Warehouse)
        if (commonFun.isNotEmpty(row.transportationRate) && commonFun.isNotEmpty(row.warehouseRate)) {
          var adpCost = this.utils.add([row.transportationRate, row.warehouseRate], 6)
          this.$set(row, 'adpCost', adpCost)
        } else {
          this.$set(row, 'adpCost', null)
        }
        console.log("Transportation ~  Total ADP Cost(without VAT):", adpCost)

        if (commonFun.isNotEmpty(row.adpCost) && commonFun.isNotEmpty(row.currentAdpCost)) {
          // var adpChange = this.utils.formatFloat((Number(row.adpCost) / Number(row.currentAdpCost) - 1), 2)
          var adp_div = new Decimal(row.adpCost).div(new Decimal(row.currentAdpCost)).toNumber();
          console.log("🚀 ~ file: newFpaDetail.vue:2594 ~ transportationRateChange ~ adp_div:", adp_div)
          var adp_sub = new Decimal(adp_div).sub(new Decimal(1)).toNumber();
          // var adp_mul = this.utils.mul(adp_sub, 100, 2)
          // console.log("🚀 ~ file: newFpaDetail.vue:2598 ~ transportationRateChange ~ adp_mul:", adp_mul)
          // var adpChange = adp_mul + '%'
          this.$set(row, 'adpChange', adp_sub)
        } else {
          this.$set(row, 'adpChange', null)
        }
        console.log("Transportation ~ Change:", adp_sub)

        // Total ADP Cost(with VAT)=New Item Rate with VAT(Transportation+Warehouse)
        if (commonFun.isNotEmpty(row.transportationRateWithVat) && commonFun.isNotEmpty(row.warehouseRateWithVat)) {
          var adpCostWithVat = this.utils.add([row.transportationRateWithVat, row.warehouseRateWithVat], 6)
          this.$set(row, 'adpCostWithVat', adpCostWithVat)
        } else {
          this.$set(row, 'adpCostWithVat', null)
        }
        console.log("Transportation ~ Total ADP Cost(with VAT):", adpCostWithVat)

        // Total Estimated Value(with VAT)=Total ADP Cost(with VAT)*Volume  Estimation 千位符 2位小数
        if (commonFun.isNotEmpty(row.adpCostWithVat) && commonFun.isNotEmpty(row.estVolume)) {
          // var totalEstimatedValue = this.utils.formatThousand(Number(row.adpCostWithVat) * Number(row.estVolume))
          var totalEstimatedValue = this.utils.mul(row.adpCostWithVat, row.estVolume, 2)
          // var totalEstimatedValueThousand = this.utils.formatThousand(totalEstimatedValue)
          this.$set(row, 'totalEstimatedValue', totalEstimatedValue)
        } else {
          this.$set(row, 'totalEstimatedValue', null)
        }
        console.log("Transportation ~ Total Estimated Value(with VAT):", totalEstimatedValue)
      } else {
        this.$set(row, 'transportationRateWithVat', null)
        this.$set(row, 'transportationVatValue', null)
        this.$set(row, 'adpCost', null)
        this.$set(row, 'adpCostWithVat', null)
        this.$set(row, 'totalEstimatedValue', null)
        this.$set(row, 'adpChange', null)
      }
      this.$forceUpdate();
    },
    // Warehouse -> New Item Rate without VAT值变化
    warehouseRateChange(row) {
      if (commonFun.isNotEmpty(row.warehouseRate)) {
        let reg = /^\d+(\.\d+)?$/
        if (!reg.test(row.warehouseRate)) {
          this.$set(row, "warehouseRate", '');
        } else {
          this.$set(row, "warehouseRate", (row.warehouseRate * 1).toFixed(6));
        }

        if (commonFun.isNotEmpty(row.warehouseVat)) {
          // New Item Rate with VAT=New Item Rate without VAT*(1+VAT Rate)
          var num1 = 1 + Number(row.warehouseVat)
          console.log("Warehouse ~ num1:", num1)
          var warehouseRateWithVat = this.utils.mul(row.warehouseRate, num1, 6)
          this.$set(row, 'warehouseRateWithVat', warehouseRateWithVat)
          console.log("Warehouse ~ New Item Rate with VAT:", warehouseRateWithVat)
          // New Item VAT Value=New Item Rate without VAT*VAT Rate
          // var num2 = Number(row.warehouseRate) * Number(row.warehouseVat)
          // console.log("Warehouse ~ num2:", num2)
          var warehouseVatValue = this.utils.mul(row.warehouseRate, row.warehouseVat, 6)
          this.$set(row, 'warehouseVatValue', warehouseVatValue)
          console.log("Warehouse ~ New Item VAT Value:", warehouseVatValue)
        } else {
          this.$set(row, 'warehouseRateWithVat', null)
          this.$set(row, 'warehouseVatValue', null)
        }

        // Total ADP Cost(without VAT)=New Item Rate without VAT(Transportation+Warehouse)
        if (commonFun.isNotEmpty(row.transportationRate) && commonFun.isNotEmpty(row.warehouseRate)) {
          var adpCost = this.utils.add([row.transportationRate, row.warehouseRate], 6)
          this.$set(row, 'adpCost', adpCost)
        } else {
          this.$set(row, 'adpCost', null)
        }
        console.log("Warehouse ~ Total ADP Cost(without VAT):", adpCost)

        if (commonFun.isNotEmpty(row.adpCost) && commonFun.isNotEmpty(row.currentAdpCost)) {
          var adp_div = new Decimal(row.adpCost).div(new Decimal(row.currentAdpCost)).toNumber();
          console.log("🚀 ~ file: newFpaDetail.vue:2682 ~ warehouseRateChange ~ adp_div:", adp_div)
          var adp_sub = new Decimal(adp_div).sub(new Decimal(1)).toNumber();
          // var adp_mul = this.utils.mul(adp_sub, 100, 2)
          // console.log("🚀 ~ file: newFpaDetail.vue:2686 ~ warehouseRateChange ~ adp_mul:", adp_mul)
          // var adpChange = adp_mul + '%'
          this.$set(row, 'adpChange', adp_sub)
        } else {
          this.$set(row, 'adpChange', null)
        }
        console.log("Warehouse ~ Change:", adp_sub)

        // Total ADP Cost(with VAT)=New Item Rate with VAT(Transportation+Warehouse)
        if (commonFun.isNotEmpty(row.transportationRateWithVat) && commonFun.isNotEmpty(row.warehouseRateWithVat)) {
          var adpCostWithVat = this.utils.add([row.transportationRateWithVat, row.warehouseRateWithVat], 6)
          this.$set(row, 'adpCostWithVat', adpCostWithVat)
        } else {
          this.$set(row, 'adpCostWithVat', null)
        }
        console.log("Warehouse ~ Total ADP Cost(with VAT):", adpCostWithVat)

        // Total Estimated Value(with VAT)=Total ADP Cost(with VAT)*Volume  Estimation 千位符 2位小数
        if (commonFun.isNotEmpty(row.adpCostWithVat) && commonFun.isNotEmpty(row.estVolume)) {
          // var totalEstimatedValue = this.utils.formatThousand(Number(row.adpCostWithVat) * Number(row.estVolume))
          var totalEstimatedValue = this.utils.mul(row.adpCostWithVat, row.estVolume, 2)
          // var totalEstimatedValueThousand = this.utils.formatThousand(totalEstimatedValue)
          this.$set(row, 'totalEstimatedValue', totalEstimatedValue)
        } else {
          this.$set(row, 'totalEstimatedValue', null)
        }
        console.log("Warehouse ~ Total Estimated Value(with VAT):", totalEstimatedValue)
      } else {
        this.$set(row, 'warehouseRateWithVat', null)
        this.$set(row, 'warehouseVatValue', null)
        this.$set(row, 'adpCost', null)
        this.$set(row, 'adpCostWithVat', null)
        this.$set(row, 'totalEstimatedValue', null)
        this.$set(row, 'adpChange', null)
      }
      this.$forceUpdate();
    },
    // Transportation -> VAT Rate值变化
    transportationVatChange(row, value) {
      if (commonFun.isNotEmpty(row.transportationVat) && commonFun.isNotEmpty(row.transportationRate)) {
        // New Item Rate with VAT=New Item Rate without VAT*(1+VAT Rate)
        var num1 = 1 + Number(row.transportationVat)
        console.log("Transportation -> VAT Rate值变化 ~ num1:", num1)
        var transportationRateWithVat = this.utils.mul(row.transportationRate, num1, 6)
        this.$set(row, 'transportationRateWithVat', transportationRateWithVat)
        console.log("Transportation -> VAT Rate值变化 ~ New Item Rate with VAT:", transportationRateWithVat)
        // New Item VAT Value=New Item Rate without VAT*VAT Rate
        // var num2 = Number(row.transportationRate) * Number(row.transportationVat)
        // console.log("Transportation -> VAT Rate值变化 ~ num2:", num2)
        var transportationVatValue = this.utils.mul(row.transportationRate, row.transportationVat, 6)
        this.$set(row, 'transportationVatValue', transportationVatValue)
        console.log("Transportation -> VAT Rate值变化 ~ New Item VAT Value:", transportationVatValue)
      } else {
        this.$set(row, 'transportationRateWithVat', null)
        this.$set(row, 'transportationVatValue', null)
      }

      // Total ADP Cost(with VAT)=New Item Rate with VAT(Transportation+Warehouse)
      if (commonFun.isNotEmpty(row.transportationRateWithVat) && commonFun.isNotEmpty(row.warehouseRateWithVat)) {
        var adpCostWithVat = this.utils.add([row.transportationRateWithVat, row.warehouseRateWithVat], 6)
        this.$set(row, 'adpCostWithVat', adpCostWithVat)
      } else {
        this.$set(row, 'adpCostWithVat', null)
      }
      console.log("Transportation -> VAT Rate值变化 ~ Total ADP Cost(with VAT):", adpCostWithVat)

      // Total Estimated Value(with VAT)=Total ADP Cost(with VAT)*Volume  Estimation 千位符 2位小数
      if (commonFun.isNotEmpty(row.adpCostWithVat) && commonFun.isNotEmpty(row.estVolume)) {
        var totalEstimatedValue = this.utils.mul(row.adpCostWithVat, row.estVolume, 2)
        // var totalEstimatedValueThousand = this.utils.formatThousand(totalEstimatedValue)
        this.$set(row, 'totalEstimatedValue', totalEstimatedValue)
      } else {
        this.$set(row, 'totalEstimatedValue', null)
      }
      console.log("Transportation -> VAT Rate值变化 ~ Total Estimated Value(with VAT):", totalEstimatedValue)
      this.$forceUpdate();
    },
    // Warehouse -> VAT Rate值变化
    warehouseVatChange(row, value) {
      if (commonFun.isNotEmpty(row.warehouseVat) && commonFun.isNotEmpty(row.warehouseRate)) {
        // New Item Rate with VAT=New Item Rate without VAT*(1+VAT Rate)
        var num1 = 1 + Number(row.warehouseVat)
        console.log("Warehouse -> VAT Rate值变化 ~ num1:", num1)
        var warehouseRateWithVat = this.utils.mul(row.warehouseRate, num1, 6)
        this.$set(row, 'warehouseRateWithVat', warehouseRateWithVat)
        console.log("Warehouse -> VAT Rate值变化 ~ New Item Rate with VAT:", warehouseRateWithVat)
        // New Item VAT Value=New Item Rate without VAT*VAT Rate
        // var num2 = Number(row.warehouseRate) * Number(row.warehouseVat)
        // console.log("Warehouse -> VAT Rate值变化 ~ num2:", num2)
        var warehouseVatValue = this.utils.mul(row.warehouseRate, row.warehouseVat, 6)
        this.$set(row, 'warehouseVatValue', warehouseVatValue)
        console.log("Warehouse -> VAT Rate值变化 ~ New Item VAT Value:", warehouseVatValue)
      } else {
        this.$set(row, 'warehouseRateWithVat', null)
        this.$set(row, 'warehouseVatValue', null)
      }

      // Total ADP Cost(with VAT)=New Item Rate with VAT(Transportation+Warehouse)
      if (commonFun.isNotEmpty(row.transportationRateWithVat) && commonFun.isNotEmpty(row.warehouseRateWithVat)) {
        var adpCostWithVat = this.utils.add([row.transportationRateWithVat, row.warehouseRateWithVat], 6)
        this.$set(row, 'adpCostWithVat', adpCostWithVat)
      } else {
        this.$set(row, 'adpCostWithVat', null)
      }
      console.log("Warehouse -> VAT Rate值变化 ~ Total ADP Cost(with VAT):", adpCostWithVat)

      // Total Estimated Value(with VAT)=Total ADP Cost(with VAT)*Volume  Estimation
      if (commonFun.isNotEmpty(row.adpCostWithVat) && commonFun.isNotEmpty(row.estVolume)) {
        var totalEstimatedValue = this.utils.mul(row.adpCostWithVat, row.estVolume, 2)
        // var totalEstimatedValueThousand = this.utils.formatThousand(totalEstimatedValue)
        this.$set(row, 'totalEstimatedValue', totalEstimatedValue)
      } else {
        this.$set(row, 'totalEstimatedValue', null)
      }
      console.log("Warehouse -> VAT Rate值变化 ~ Total Estimated Value(with VAT):", totalEstimatedValue)
      this.$forceUpdate();
    },
    estVolumeChange(row) {
      if (commonFun.isNotEmpty(row.estVolume)) {
        let reg = /^\d+(\.\d+)?$/
        if (!reg.test(row.estVolume)) {
          this.$set(row, "estVolume", '');
        } else {
          this.$set(row, "estVolume", (row.estVolume * 1).toFixed(2));
        }
      }
      if (commonFun.isNotEmpty(row.adpCostWithVat) && commonFun.isNotEmpty(row.estVolume)) {
        var totalEstimatedValue = this.utils.mul(row.adpCostWithVat, row.estVolume, 2)
        // var totalEstimatedValueThousand = this.utils.formatThousand(totalEstimatedValue)
        this.$set(row, 'totalEstimatedValue', totalEstimatedValue)
      } else {
        this.$set(row, 'totalEstimatedValue', null)
      }
      this.$forceUpdate();
    },
    isNumber(val) {
      var reg = new RegExp("^\\d+(\\.\\d+)?$");
      if (val && reg.test(val) && (0 == val || parseFloat(val))) {
        return true;
      } else {
        if (val == null || val == undefined || val == "") {
          return false;
        }
        //请输入六位小数数字！
        this.$message.error(this.$t('fpaManage.permanent.numSixBitCheck'));
        return false;
      }
    },
    //fpaPqcnList选择操作
    handleFpaPqcnChange(row) {
      this.fpaPqcnSelect = row;
    },
    fpaPqcnAdd() {
      if (utils.isEmpty(this.formData.fpaSupplierCoverageList) && this.formData.category2 != 'Toys') {
        //请先选择工厂！
        this.$message.error(this.$t('fpaManage.permanent.pleaseChooseSupplier'))
        return false;
      }

      let index = 0;
      if (utils.isEmpty(this.formData.fpaPqcnList)) {
        this.formData.fpaPqcnList = [];
      } else {
        let ttFpaPqcnIdArr = this.formData.fpaPqcnList.map(row => row.ttFpaPqcnId);
        ttFpaPqcnIdArr = ttFpaPqcnIdArr.sort((a, b) => a - b);
        index = parseInt(ttFpaPqcnIdArr[ttFpaPqcnIdArr.length - 1]);
      }
      let currency = commonFun.isEmpty(this.formData.currency) ? 'RMB' : this.formData.currency;
      let fpaPqcn = {
        ttFpaPqcnId: index + 1,
        isNew: 'N',
        suppliedDcArr: [],
        newBoolean: false,
        currency: currency,
        plantId: null,
        localItem: '',
        tradeTerm: null,
        tradeTermDescription: null,
        productDescription: null,
        packingSizePerUom: null,
        uom: null,
        newPricePerUom: null,
        vat: null,
        ddpCost: null,
        change: null,
        transportaionMethod: null,
        validFrom: null,
        validTo: null,
        volumeEstimation: null,
        contentPerUom: null,
        unit: null,
        pricePerUnit: null,
        freight: null,
        originalDeliveryType: null,
      };
      this.formData.fpaPqcnList.push(fpaPqcn);
      // if (commonFun.isNotEmpty(this.formData.fpaPqcnList)) {
      //   this.$refs.fpaPqcnList.reloadData(this.formData.fpaPqcnList);
      // }
      this.$forceUpdate();
    },
    fpaPqcnDel() {
      let that = this;
      if (that.fpaPqcnSelect.length == 0) {
        //请选择需要删除的记录！
        this.$message.error(this.$t('fpaManage.permanent.pleaseChooseToDelete'))
        return false;
      }
      //您确定要删除所选记录吗？
      that.$confirm('Are you sure to delete these records?', 'Tips', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        customClass: 'colorBtn',
        cancelButtonClass: 'btn_custom_cancel',
        type: 'warning'
      }).then(() => {
        this.tableVisible = false;
        that.fpaPqcnSelect.forEach((val) => {
          that.formData.fpaPqcnList.forEach((allVal, index) => {
            if (val.ttFpaPqcnId == allVal.ttFpaPqcnId) {
              that.formData.fpaPqcnList.splice(index, 1);
            }
          })
        })
        //如果没有$nextTick，就不会生效，这样强制保证在下个循环来显示table
        this.$nextTick(() => {
          this.tableVisible = true;
        })
        that.fpaPqcnSelect.length = [];

        if (commonFun.isNotEmpty(that.formData.fpaPqcnList)) {
          let notionalValueOfAgreement = 0;
          that.formData.fpaPqcnList.forEach(pqcn => {
            if (commonFun.isNotEmpty(pqcn.ddpCost) && commonFun.isNotEmpty(pqcn.volumeEstimation) && commonFun.isNotEmpty(pqcn.vat)) {
              notionalValueOfAgreement += parseFloat(pqcn.ddpCost * pqcn.volumeEstimation * (1 + pqcn.vat * 1));
            }
          })
          // notionalValueOfAgreement = Number(notionalValueOfAgreement).toFixed(2)
          notionalValueOfAgreement = this.utils.formatFloat(Number(notionalValueOfAgreement), 2)
          this.formData.notionalValueOfAgreement = this.utils.formatThousand(notionalValueOfAgreement)
        } else {
          that.formData.notionalValueOfAgreement = 0;
        }
        // if (commonFun.isNotEmpty(that.formData.fpaPqcnList)) {
        //   that.$refs.fpaPqcnList.reloadData(that.formData.fpaPqcnList);
        // }
      })
    },
    inputLocalItemCopy(row) {
      let that = this;
      if (row.isNew == 'N' && !utils.isEmpty(row.localItem)) {
        let ttFpaPqcnId = row.ttFpaPqcnId;
        return fpaPermanentApi.fpaMaterialSearch(row.localItem).then((res) => {
          if (res.data) {
            if (res.data.ttFpaPqcnId == -1) {
              //请输入可用物料!
              this.$message.error(this.$t('fpaManage.permanent.localItemExistCheck'))
              return false;
            }
            this.$set(row, 'plantId', res.data.plantId);
            this.$set(row, 'facilityName', res.data.facilityName);
            this.$set(row, 'tradeTerm', res.data.tradeTerm);
            this.$set(row, 'temperature', res.data.temperature);
            this.$set(row, 'productDescription', res.data.productDescription);
            this.$set(row, 'suppliedDcArr', res.data.suppliedDcArr);
            this.$set(row, 'uom', res.data.uom);
            if (that.formData.category2 != 'Toys') {
              this.$set(row, 'currency', 'RMB');
            }
            this.$set(row, 'currentPricePerUom', res.data.currentPricePerUom);
            if (res.data.transportaionMethod) {
              if ("DC_SUPPLIER_DC" != res.data.transportaionMethod) {
                this.$set(row, 'transportaionMethod', res.data.transportaionMethod);
              } else {
                this.$set(row, 'transportaionMethod', null);
              }
            } else {
              this.$set(row, 'transportaionMethod', 'DC');//DC自提
            }
            // this.$set(row, 'freight', res.data.freight);
            this.$set(row, 'remark', res.data.remark);
            //packingSizePerUom 拼接出来的字符串=外包装内含内包装数量*内包装内含UOM数量（UOM字段的单位值）
            //例如： '12*23 加仑'
            let packingSizePerUom = '';
            if (res.data.outerPackageContainsNum) {
              packingSizePerUom += res.data.outerPackageContainsNum;
            }
            packingSizePerUom += '*';
            if (res.data.quantityUomInnerNum) {
              packingSizePerUom += res.data.quantityUomInnerNum;
            }
            if (res.data.uomValue) {
              packingSizePerUom += ' ' + res.data.uomValue;
            }
            this.$set(row, 'packingSizePerUom', packingSizePerUom);

            if (row.transportaionMethod == "SUPPLIER") {
              this.$set(row, "suppliedDcArr", ["-1"]);
            } else if (row.transportaionMethod != "SUPPLIER" && row.suppliedDcArr != null && row.suppliedDcArr.length == 1 && row.suppliedDcArr[0] == "-1") {
              this.$set(row, "suppliedDcArr", []);
            }
          } else {
            Message.error(res.msg || 'Operate error');
          }
          this.countPqcp(row);
        })
      } else {
        return new Promise(resolve => resolve());
      }
    },
    inputLocalItem(row) {
      let that = this;
      if (row.isNew == 'N' && !utils.isEmpty(row.localItem)) {
        let ttFpaPqcnId = row.ttFpaPqcnId;
        return fpaPermanentApi.fpaMaterialSearch(row.localItem).then((res) => {
          if (res.data) {
            if (res.data.ttFpaPqcnId == -1) {
              //请输入可用物料!
              this.$message.error(this.$t('fpaManage.permanent.localItemExistCheck'))
              return false;
            }
            this.$set(row, 'plantId', res.data.plantId);
            this.$set(row, 'facilityName', res.data.facilityName);
            this.$set(row, 'tradeTerm', res.data.tradeTerm);
            this.$set(row, 'temperature', res.data.temperature);
            this.$set(row, 'productDescription', res.data.productDescription);
            this.$set(row, 'suppliedDcArr', res.data.suppliedDcArr);
            this.$set(row, 'uom', res.data.uom);
            this.$set(row, 'vat', res.data.vat);
            if (that.formData.category2 != 'Toys') {
              this.$set(row, 'currency', 'RMB');
            }
            this.$set(row, 'currentPricePerUom', res.data.currentPricePerUom);
            if (res.data.transportaionMethod) {
              if ("DC_SUPPLIER_DC" != res.data.transportaionMethod) {
                this.$set(row, 'transportaionMethod', res.data.transportaionMethod);
              } else {
                this.$set(row, 'transportaionMethod', null);
              }
              this.$set(row, 'originalDeliveryType', res.data.transportaionMethod);
            } else {
              this.$set(row, 'transportaionMethod', 'DC');//DC自提
            }
            this.$set(row, 'freight', res.data.freight);
            this.$set(row, 'remark', res.data.remark);
            //packingSizePerUom 拼接出来的字符串=外包装内含内包装数量*内包装内含UOM数量（UOM字段的单位值）
            //例如： '12*23 加仑'
            let packingSizePerUom = '';
            if (res.data.outerPackageContainsNum) {
              packingSizePerUom += res.data.outerPackageContainsNum;
            }
            packingSizePerUom += '*';
            if (res.data.quantityUomInnerNum) {
              packingSizePerUom += res.data.quantityUomInnerNum;
            }
            if (res.data.uomValue) {
              packingSizePerUom += ' ' + res.data.uomValue;
            }
            this.$set(row, 'packingSizePerUom', packingSizePerUom);

            if (row.transportaionMethod == "SUPPLIER") {
              this.$set(row, "suppliedDcArr", ["-1"]);
            } else if (row.transportaionMethod != "SUPPLIER" && row.suppliedDcArr != null && row.suppliedDcArr.length == 1 && row.suppliedDcArr[0] == "-1") {
              this.$set(row, "suppliedDcArr", []);
            }
          } else {
            Message.error(res.msg || 'Operate error');
          }
          this.countPqcp(row);
        })
      } else {
        return new Promise(resolve => resolve());
      }

    },
    isNewChange(row, newBoolean) {
      // if (this.formData.category2 == 'Toys') {
      //   return;
      // }
      let isNew = 'N';
      if (newBoolean) {
        isNew = 'Y';
      }
      this.$set(row, 'plantId', '');
      this.$set(row, 'facilityName', '');
      this.$set(row, 'ttFpaPqcnId', row.ttFpaPqcnId);
      this.$set(row, 'currency', 'RMB');
      this.$set(row, 'newBoolean', newBoolean);
      this.$set(row, 'isNew', isNew);
      this.$set(row, 'localItem', '');
      this.$set(row, 'packingSizePerUom', '');
      this.$set(row, 'transportaionMethod', '');
      this.$set(row, 'tradeTerm', '');
      this.$set(row, 'tradeTermDescription', '');
      //this.$set(row,'temperature','');
      this.$set(row, 'productDescription', '');
      this.$set(row, 'suppliedDcArr', []);
      this.$set(row, 'ddpCost', '');
      this.$set(row, 'uom', '');
      this.$set(row, 'vat', '');
      this.$set(row, 'currentPricePerUom', null);
      this.$set(row, 'remark', '');
      this.$set(row, 'validFrom', '');
      this.$set(row, 'validTo', '');
      this.$set(row, 'freight', '');
    },
    pqcpTradeTermChange(row) {
    },
    returnToSu() {
      this.showRejectPage = true;
    },
    finishRouterBack(res) {
      if (res.data) {
        this.routerBack();
      } else {
        this.$message.error(res.msg || 'Operate error');
      }
    },
    routerBack() {
      if (this.isRouterBack) {
        this.$router.back();
      } else {
        this.$router.push(this.menus[0].subs[0].index);
      }
    },
    tableRowClassName(row) {
      if (row.column.label == "Content Per SU" || row.column.label == "Unit" || row.column.label == "Price per Unit") {
        return 'thBackgroundColor'
      }
    },
    // 维护FPA时，校验配送类型的转换
    // delivertTypeChange(val, row, index) {
    //   console.log("GY🚀 ~ delivertTypeChange ~ row:", row.originalDeliveryType);
    //   console.log("GY🚀 ~ delivertTypeChange ~ val:", val);
    //   if ((val == 'DC' || val == 'SUPPLIER_DC') && row.originalDeliveryType == 'SUPPLIER') {
    //     this.$confirm('物料' + row.localItem + '的配送类型为直送门店，但维护却是非直送门店，请确认是否为业务变更？如确认变更，请点击确认，如需修改，请点击取消。', {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       type: 'warning'
    //     }).then(() => {

    //     }).catch(() => {
    //       this.$message({
    //         type: 'info',
    //         message: '已取消维护'
    //       });
    //       this.formData.fpaPqcnList[index].transportaionMethod = row.originalDeliveryType
    //     });
    //   } else if ((row.originalDeliveryType == 'DC' || row.originalDeliveryType == 'SUPPLIER_DC') && val == 'SUPPLIER') {
    //     this.$confirm('物料' + row.localItem + '配送类型为非直送门店，但维护的却是直送门店，请确认是否为业务变更？如确认变更，请点击确认，如需修改，请点击取消。', {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       type: 'warning'
    //     }).then(() => {

    //     }).catch(() => {
    //       this.$message({
    //         type: 'info',
    //         message: '已取消维护'
    //       });
    //       this.formData.fpaPqcnList[index].transportaionMethod = row.originalDeliveryType
    //     });
    //   }


    // },
    getCurrentFreight(row) {
      let that = this;
      let data = {
        dcIdList: row.suppliedDcArr,
        eightBitCode: row.localItem,
      };
      if (commonFun.isEmpty(row.localItem)) {
        return;
      }
      that.$set(row, "currentFreight", null);
      if (row.transportaionMethod == "SUPPLIER") {
        fpaPermanentApi.getCurrentDirectFreight(row.localItem).then(res => {
          if (res.code == 200) {
            that.$set(row, "currentFreight", res.data);
          }
        });
      } else if (row.transportaionMethod == "SUPPLIER_DC") {
        materialPriceDataApi.listProductFreightByMaterialCode(data).then(res => {
          if (res.code == 200) {
            if (commonFun.isNotEmpty(res.data)) {
              that.$set(row, "currentFreight", res.data[0].productPrice);
            }
          }
        });
      }
    },
    handleInput(row) {
      let value = row['supplyQty'];
      let formattedValue = value.replace(/[^\d]/g, '');
      if (/^0+[1-9]/.test(formattedValue)) {
        formattedValue = formattedValue.replace(/^0+/, '');
      } else if (/^0/.test(formattedValue)) {
        formattedValue = '';
      }
      this.$set(row, "supplyQty", formattedValue);
    }
  },
  extends: commonFunction,
};
</script>
<style lang="scss" scoped>
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  display: inline-block;
}

// 整体内容
.fpaDetail {
  width: calc(100% - 20px);
  padding: 10px;
  background-color: #fff;
}
// 第一行只可view
.view_content {
  height: 50px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.35);
  border-radius: 6px;
  margin-top: 10px;
  display: flex;
  align-content: center;
  justify-content: space-between;
  .fpaNo,
  .status,
  .creator,
  .createDate {
    width: 20%;
    height: 40px;
    padding: 5px 0;
    text-align: center;
    border-right: 1px solid #ddd;
    p {
      height: 20px;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .approver {
    width: 20%;
    height: 40px;
    padding: 5px 0;
    text-align: center;
    p {
      height: 20px;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
// 第二行整体
.info_box {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
.info_box_lf,
.info_box_rg {
  border-radius: 6px;
  padding: 0 10px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.35);
}
// Basic Information
.info_box_lf {
  width: 60%;
  margin-right: 20px;
}
// Notional  Value of Agreement
.info_box_rg {
  // flex: 1;
  width: 38%;
  overflow: hidden;
  position: relative;
}
.default_clause {
  width: 38%;
  overflow: hidden;
  position: relative;
  border-radius: 6px;
  padding: 0 10px;
  box-shadow: 0 0 5px 0 rgba(248, 171, 1, 1);
}
// 模块的标题
.info_box_title {
  height: 30px;
  margin-top: 10px !important;
  display: flex;
  flex-direction: row;
  justify-content: start;
}
.info_title {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  margin-left: 5px;
}
.line {
  width: 3px;
  height: 16px;
  margin: 7px 0;
  background-color: #f8ab01;
}
.label_icon {
  display: inline-block;
  height: 32px;
  line-height: 32px;
  margin-right: 10px;
}

.btn {
  width: 100%;
  height: 50px;
  padding: 0 20px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.35);
  border-radius: 6px;
}

.price_box2 {
  width: 80%;
  height: 85px;
  // line-height: 85px;
  font-size: 34px;
  margin: 0 auto;
  color: #f8ab01;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px dashed #f8ab01;
  .qian {
    margin: 0 30px 0 50px;
  }
  .notional_qian {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 85px;
    line-height: 85px;
  }
}
.totalForm {
  height: 33px;
  margin-bottom: 18px;
}
.price_info,
.cost_analysis {
  //width: 60%;
  //margin-right: 20px;
  background-color: #fff;
  border-radius: 6px;
  padding: 0 10px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.35);
}
.tab_box {
  background-color: #fff;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.35);
  padding: 10px;
  margin-top: 10px;
  border-radius: 6px;
}
.total_box {
  position: absolute;
  bottom: 0px;
}
.table-d {
  border-collapse: collapse;
  margin-bottom: 12px;
  font-size: 12px;
  width: 100%;
  .el-form-item--mini.el-form-item,
  .el-form-item--small.el-form-item {
    margin-bottom: 0px !important;
  }
}
.table-d td {
  border: 1px solid #ebeef5;
  text-align: center;
  padding: 9px 10px 10px;
  width: 23%;
}
.table-d .title {
  background: #fafafa;
}
</style>